import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

// --- Third-Party Libraries ---
import { useTheme, styled } from '@mui/material/styles';
import { Bar, Doughnut } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip as ChartJsTooltip, CategoryScale, LinearScale, BarElement, ChartData } from 'chart.js';

import {
    RiCalendarView,
    RiArchiveDrawerLine,
    RiArchiveStackLine,
    RiBubbleChartLine,
    RiGroupLine,
	RiAiGenerate,
  RiLineChartLine,
   RiErrorWarningLine, // Add this line
} from "react-icons/ri";

// --- Material-UI Components ---
import {
    Typography,
    Box,
    Card,
    CardContent,
    CardMedia,
    ListItem,
    Divider,
    Button,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Avatar,
    IconButton,
    TextField,
    Tooltip,
    Menu,
    MenuItem,
	Grid,
    Stack,
    Select,
    Chip,
} from '@mui/material';

// --- Material-UI Icons ---
import {
    ArrowForwardIosOutlined,
    ExpandMore,
    ArrowForwardIos as ArrowForwardIosIcon
} from "@mui/icons-material";

// --- Local Project Imports ---
import MainDrawer from "./MainDrawer";
import queryGraphql from "../helpers/ApiInterface";
import { useAuth } from "../helpers/AuthProvider";
import MiniBot from "./MiniBot";
import { is } from "date-fns/locale";


// --- Library Initializations ---
// It's best practice to register Chart.js components once at the top level.
Chart.register(ArcElement, ChartJsTooltip, CategoryScale, LinearScale, BarElement);


let navPaneList: any = [

  {
    id: "clusters",
    text: "Clusters",
    nav: "/clusters",
    icon: <RiArchiveDrawerLine />,
    visibility: ["cluster_owner", "viewer"],
  },
  {
    id: "applications",
    text: "Applications",
    nav: "/applications",
    icon: <RiArchiveStackLine />,
    visibility: [
      "application_owner",
      "developer",
	  "viewer"
    ],
  },
  {
    id: "services",
    text: "Services",
    nav: "/services",
    icon: <RiBubbleChartLine />,
    visibility: [  "developer", "viewer"],
  },
    {
      id: "user-management",
      text: "User",
      icon: <RiGroupLine />,
      nav: "/user-management",
      visibility: ["idp_admin", "viewer"],
    },
	{
			id: "requests-cluster",
			text: "Request/Clusters",
			icon: <RiArchiveDrawerLine />,
			nav: "/requests/clusters",
			visibility: ["infrastructure_admin", "viewer"],
		  },
		  {
			id: "requests-application",
			text: "Requests/Applications",
			icon: <RiArchiveStackLine />,
			nav: "/requests/applications",
			visibility: ["infrastructure_admin", "viewer"],
		  },
		  {
			id: "requests-service",
			text: "Requests/Services",
			icon: <RiBubbleChartLine />,
			nav: "/requests/services",
			visibility: ["application_owner", "viewer"],
		  },
 
];

// --- STYLED COMPONENT for Security Toggle Buttons ---
// --- STYLED COMPONENT for Security Toggle Buttons (from new component) ---
const ToolIconButton = styled(IconButton, {
  // This option prevents the custom 'selected' prop from being passed to the DOM element
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
    backgroundColor: 'transparent',
    //border: selected ? `1px solid ${theme.palette.divider}` : `1px solid transparent`,
    //boxShadow: selected ? '0px 4px 12px rgba(0,0,0,0.08)' : 'none',
    '&:hover': {
        backgroundColor: theme.palette.common.white,
        boxShadow: '0px 4px 12px rgba(0,0,0,0.08)',
    },
    width: 56,
    height: 56,
    borderRadius: '70px',
    padding: 0
}));



type MetricItemProps = {
  icon: React.ReactNode;
  value: number;
  label: string;
};
const MetricItem = ({ icon, value, label }: MetricItemProps) => (
  <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    flex: 1,
  }}>
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: "24px",
      height: "24px",
      backgroundColor: '#f0f0f0',
      borderRadius: '50%',
      mb: 2,
    }}>
      {icon}
    </Box>
    <Typography fontFamily="Gilroy-Bold" fontSize="18px" color="#232324" component="div">
      {value}
    </Typography>
    <Typography fontFamily="Gilroy-Regular" fontSize="14px" color="#232324">
      {label}
    </Typography>
  </Box>
);
// const LeftBox = styled(Box)(({ theme }) => ({
//   flex: '70%', // Takes 70% of the parent's width
//   backgroundColor: '#f0f0f0',
//   // padding: theme.spacing(2),
//   borderTop: '1px solid #E4E7EC',
//   borderRight:'1px solid #E4E7EC',
//   maxHeight:'90vh',
//   overflowY: "auto",
//   minWidth:'0',
//   display:"flex",
//   flexDirection:'column'
// }));
const LeftBox = styled(Box)(({ theme }) => ({
  flex: 1, // This makes the box grow to fill available space
  backgroundColor: '#f0f0f0',
  // padding: theme.spacing(2),
  borderTop: '1px solid #E4E7EC',
  borderRight:'1px solid #E4E7EC',
  maxHeight:'90vh',
  overflowY: "auto",
  minWidth:'0',
  display:"flex",
  flexDirection:'column'
}));

// const RightBox = styled(Box)(({ theme }) => ({
//   flex: '30%', // Takes 30% of the parent's width
//   backgroundColor: '#FFFFFF', 
//   padding: theme.spacing(2), 
//   borderTop: '1px solid #E4E7EC',
//   maxHeight:'86vh',overflowY: "auto",
//   minWidth:'30vw',
//   display:"flex",
//   flexDirection:'column'
// }));
const RightBox = styled(Box)(({ theme }) => ({
  width: '396px',      // Set a fixed width
  flexShrink: 0,       // Prevent the box from shrinking
  backgroundColor: '#FFFFFF',
  padding: theme.spacing(2),
  borderTop: '1px solid #E4E7EC',
  maxHeight:'86vh',overflowY: "auto",
  display:"flex",
  flexDirection:'column'
}));

  const knowledgeBankData = [
	{ title: "Next has something for everyone.", author: 'Google', date: '01/02/2025',  content: "Get a front-row seat for Google’s latest and greatest AI innovations and product launches, and learn new ways to drive growth and efficiency.", image: "/assets/kb_1.webp" , url: "https://cloud.withgoogle.com/next/25"},
	{ title: 'See you there!!', author: 'Searce', date: '01/01/2024',  content: "Assess your organization's current AI maturity level, gain valuable insights, and qualify for a complimentary session with Searce experts.", image:"/assets/kb_2.svg", url: "https://www.searce.com/googleNext2024" },
	
  ];

  type RoleKey = "idp_admin" | "infrastructure_admin" | "cluster_owner" | "application_owner" | "developer" | "viewer";
  type Questions = "general" | "cluster" | "application" | "service" ;
  type times = "1hr" | "24hrs" |"All";
  const timeList = ["1hr","24hrs","All"];
  


  const questions = {
	general : [
	{
			question: "What is the significance of Intellicore?",
			answer: "Intellicore provides a self-service environment for you to easily create and manage your cloud infrastructure. You can build Kubernetes clusters, deploy applications, and configure various services, all through a user-friendly interface."
	},
	{
		question: "Who can use Intellicore?",
		answer: "Intellicore is designed for developers, DevOps engineers, and IT professionals who need to deploy and manage applications in a cloud environment. Access is granted based on roles and permissions defined by your organization's administrator."
	},
	{
		question: "What are the different roles on Intellicore?",
		answer: "Different roles provide different levels of authorized access within Intellicore. Different roles are- IDP Admin, Infrastructure Admin, Platform Owner, Application Owner and Developer."
	},
	{
		question: "Who is an IDP Admin",
		answer: "An IDP admin plays a crucial role in authorizing the roles to other users on Intellicore as well as he/she observes all the activities on Intellicore. "
	},
	{
		question: "What are the key responsibilities and capabilities of Infrastructure admins and Cluster Owners?",
		answer: "Infrastructure Admin's sole role is to approve or reject the creation of clusters and applications on Intellicore. While Cluster Owner can apply for the Cluster creation.  "
	},
	,
	{
		question: "What level of access and control do Application Owner and Developers have within the Intellicore?",
		answer: "Application Owners have the access to approve the services requested by the developers. As well as they can apply for application creation on Intellicore. While developers can only apply for the services. "
	}

	],
	cluster : [
	{
			question: "What types of clusters can I create?",
			answer: "For now we can only create autopilot clusters under stable release channel."
	},
	{
			question: "How long does it take to create the cluster?",
			answer: "It totally depends on the approver, once the approver accepts the requests and also approves the MR at the backend, cluster gets created in 20 mins."

	},
	{
		question: "How do I access my cluster?",
		answer: "Once the cluster is created necessary urls are provided on Intellicore."

}
	

	],

	application : [
		{
				question: "What is an application ?",
				answer: "Application where you can deploy multiple services. It creates the necessary gitlab resources and make the basic deployments into the cluster."
		},
		{
				question: "How do I monitor my application?",
				answer: "You can monitor the application with the help of updates at the bottom of each application description page."
	
		}
	
		],

	service : [
		{
				question: "What is a service?",
				answer: "A service can be a simple microservice for an application, a user can commit the changes and it gets deployed and can be shared with others."
		},
		{
				question: "What all services are available?",
				answer: "Currently only nodejs service is available."
	
		}
	
		],
	

		
  }
  const PREDEFINED_ORDER = [
    "idp_admin",
    "infrastructure_admin",
    "cluster_owner",
    "application_owner",
    "developer", "viewer"
  ];
  // --- Interface Definitions for Policy Overview ---
interface PolicyResourceStatus {
    id: string; // Unique ID for React key prop
    name: string;
    hasFailures?: boolean;
}
interface PolicySummary {
    total: number;
    violating?: number;
    resources: PolicyResourceStatus[];
}
// --- End Interface Definitions ---

// Simple styled component for the indicator squares
const PolicyIndicatorSquare = styled(Box)(({ theme }) => ({
    width: '12px',
    height: '12px',
    borderRadius: '2px',
    margin: '2px', // Small gap between squares
}));
// Place this component definition above your DashBoardPage component or inside it
const CustomDropdownIcon = (props: { className: string }) => (
    <Box
        component="img"
        src="/assets/arrow-down.svg" // <-- IMPORTANT: Replace with the actual path to your icon
        alt="dropdown icon"
        //className={props.className} // This applies MUI's positioning classes
        sx={{
            width: 18, // Adjust size as needed
            height: 18,
			mr:2
        }}
    />
);
const DashBoardPage: React.FC = () => {
  const USE_HARDCODED_DATA = true;
	const { user } = useAuth();
	const isViewer = user?.roles?.some(
			(role: string) => role === "viewer" 
		) || false;
	// const role = user.roles[0] as RoleKey; 
	
	const [clusters, setClusters] = useState<any>([]);
	const [applications, setApplications] = useState<any>([]);
	const [services, setServices] = useState<any>([]);
	const [bigQueryClusterCost, setBigQueryClusterCost] = useState<any>([]);
	const [bigQueryApplicationCost, setBigQueryApplicationCost] = useState<any>([]);
	const [bigQueryServiceCost, setBigQueryServiceCost] = useState<any>([]);
	const [bigQueryClusterCostRecent, setBigQueryClusterCostRecent] = useState<any>();
	const [bigQueryApplicationCostRecent, setBigQueryApplicationCostRecent] = useState<any>();
	const [bigQueryServiceCostRecent, setBigQueryServiceCostRecent] = useState<any>();
	const [integrations, setIntegrations] = useState<any>({});
	const [questionsType, setQuestionsType] = useState<string>('general');
	const qt = questionsType as Questions;
	const [updates, setUpdates] =  useState<any>([]);
	const [timeFilter,setTimeFilter] = useState<any>("24hrs");
	const navigate = useNavigate();
	    // State for Raw Checkov Results (kept in case needed elsewhere)
    const [checkovResults, setCheckovResults] = useState<any[]>([]);
	const [kyvernoResults, setKyvernoResults] = useState<any[]>([]);
    // ADDED STATE FOR PROCESSED POLICY OVERVIEW DATA
    const [clusterPolicySummary, setClusterPolicySummary] = useState<PolicySummary>({ total: 0, violating: 0, resources: [] });
    const [applicationPolicySummary, setApplicationPolicySummary] = useState<PolicySummary>({ total: 0, violating: 0, resources: [] });
    const [servicePolicySummary, setServicePolicySummary] = useState<PolicySummary>({ total: 0, violating: 0, resources: [] });
	const [kyvernoClusterPolicySummary, setKyvernoClusterPolicySummary] = useState<PolicySummary>({ total: 0, resources: [] }); // <-- ADDED for Kyverno Summary (no violating needed)

	// --- NEW STATE for the graphical Security Overview ---
const [selectedTool, setSelectedTool] = useState('checkov');
const [selectedResourceType, setSelectedResourceType] = useState('cluster'); // For the dropdown
const [securityStats, setSecurityStats] = useState({
    checkov: {
        byResourceType: {
            cluster: { total: 0, passed: 0, failed: 0, topFailing: [] as string[] },
            application: { total: 0, passed: 0, failed: 0, topFailing: [] as string[] },
            service: { total: 0, passed: 0, failed: 0, topFailing: [] as string[] },
        },
        totalPolicyChecks: 0,
    },
    kyverno: {
    cluster: { total: 0, policiesEnforced: 0, topHighSeverity: [] as string[] },
    totalPolicyChecks: 0,
}
});

    // --- End State Variables ---
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const rolesSet = new Set(user.roles);
	const roles = PREDEFINED_ORDER.filter(role => rolesSet.has(role)) ;
	const role = roles[0] as RoleKey;
	
  const handleClick = (event:any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // --- NEW useEffect to process data for the chart based on the selected tool ---
useEffect(() => {
    // --- Process Checkov Data ---

    // Replace the old block with this one
if (checkovResults.length > 0) {
    const clusterFailures = new Map<string, number>();
    const appFailures = new Map<string, number>();
    const serviceFailures = new Map<string, number>();
    
    // Use simple counters instead of Sets
    let clusterCount = 0;
    let appCount = 0;
    let serviceCount = 0;
    
    let clusterPassed = 0, clusterFailed = 0;
    let appPassed = 0, appFailed = 0;
    let svcPassed = 0, svcFailed = 0;

    checkovResults.forEach(result => {
        const failures = result.summary.failed;
        const passed = result.summary.passed;

        switch (result.resourceType) {
            case 'cluster':
                if (result.cluster?.clusterName) {
                    clusterCount++; // Increment for every cluster result
                    clusterPassed += passed;
                    clusterFailed += failures;
                    if (failures > 0) {
                        const name = result.cluster.clusterName;
                        clusterFailures.set(name, (clusterFailures.get(name) || 0) + failures);
                    }
                }
                break;
            case 'application':
                if (result.application?.applicationName) {
                    appCount++; // Increment for every application result
                    appPassed += passed;
                    appFailed += failures;
                    if (failures > 0) {
                        const name = result.application.applicationName;
                        appFailures.set(name, (appFailures.get(name) || 0) + failures);
                    }
                }
                break;
            case 'service':
                if (result.service?.serviceName) {
                    serviceCount++; // Increment for every service result
                    svcPassed += passed;
                    svcFailed += failures;
                    if (failures > 0) {
                        const name = result.service.serviceName;
                        serviceFailures.set(name, (serviceFailures.get(name) || 0) + failures);
                    }
                }
                break;
        }
    });

    const getTopFailing = (failuresMap: Map<string, number>) => Array.from(failuresMap.entries())
        .sort((a, b) => b[1] - a[1])
        .map(entry => entry[0])
        .slice(0, 3);

    setSecurityStats(prev => ({
        ...prev,
        checkov: {
            byResourceType: {
                // The 'total' now uses the simple counters
                cluster: { total: clusterCount, passed: clusterPassed, failed: clusterFailed, topFailing: getTopFailing(clusterFailures) },
                application: { total: appCount, passed: appPassed, failed: appFailed, topFailing: getTopFailing(appFailures) },
                service: { total: serviceCount, passed: svcPassed, failed: svcFailed, topFailing: getTopFailing(serviceFailures) },
            },
            totalPolicyChecks: checkovResults.length,
        }
    }));
}

    // --- Process Kyverno Data ---
    if (kyvernoResults.length > 0) {
    let totalPoliciesEnforced = 0;
    const highSeverityCounts = new Map<string, number>();
    const uniqueClusters = new Set<string>();

    kyvernoResults.forEach(result => {
        if (result.resourceType === 'cluster' && result.cluster?.clusterName) {
            const clusterName = result.cluster.clusterName;
            uniqueClusters.add(clusterName);

            // Add the number of policies from this result to the total
            totalPoliciesEnforced += result.policies.length;

            // Count high-severity policies for this cluster
            const highCount = result.policies.filter((p: any) => p.severity === 'high').length;
            if (highCount > 0) {
                highSeverityCounts.set(clusterName, (highSeverityCounts.get(clusterName) || 0) + highCount);
            }
        }
    });

    const topHighSeverityClusters = Array.from(highSeverityCounts.entries())
        .sort((a, b) => b[1] - a[1]) // Sort by count descending
        .map(entry => entry[0])      // Get just the names
        .slice(0, 3);                // Take the top 3

    setSecurityStats(prev => ({
        ...prev,
        kyverno: {
            cluster: {
                total: uniqueClusters.size,
                policiesEnforced: totalPoliciesEnforced, // Use the new total
                topHighSeverity: topHighSeverityClusters // Add the new data
            },
            totalPolicyChecks: totalPoliciesEnforced,
        }
    }));
}
}, [checkovResults, kyvernoResults]); // Dependency array updated
  
   React.useEffect(() => {
	        const fetchAndProcessCheckovData = async () => {
	            if (integrations?.checkov?.enabled === true) {
	                console.log("Checkov enabled, fetching results...");
	                try {
	                    const data = await queryGraphql(`
	                        query GetCheckovResults {
	                            getCheckovResults {
	                                id resourceId resourceType summary { passed failed }
	                                application { applicationName environment} service { serviceName } cluster { clusterName environment }
	                            }
	                        }
	                    `, {}); // Query structure assumed based on previous code
	
	                    const results = data?.getCheckovResults || [];
	                    setCheckovResults(results);
	                    console.log("Checkov raw results fetched:", results);
	
	                    // Process Data for Policy Overview
	                    const clusters: PolicyResourceStatus[] = [];
	                    const applications: PolicyResourceStatus[] = [];
	                    const services: PolicyResourceStatus[] = [];
	
	                    results.forEach((result: any) => {
	                        const hasFailures = result.summary.failed > 0;
	                        const id = result.id || result.resourceId || `fallback-${Math.random()}`; // Ensure unique key
	                        let name = 'Unknown Resource'; // Default name
	
	                        if (result.resourceType === 'cluster' && result.cluster) {
	                            name = result.cluster.clusterName + '-' + result.cluster.environment || `Cluster ${result.resourceId || result.id}`;
	                            clusters.push({ id, name, hasFailures });
	                        } else if (result.resourceType === 'application' && result.application) {
	                            name = result.application.applicationName + '-' + result.application.environment || `App ${result.resourceId || result.id}`;
	                            applications.push({ id, name, hasFailures });
	                        } else if (result.resourceType === 'service' && result.service) {
	                            name = result.service.serviceName + '-' + 'dev'|| `Service ${result.resourceId || result.id}`;
	                            services.push({ id, name, hasFailures });
	                        }
	                    });
	
	                    // Update state with processed summaries
	                    setClusterPolicySummary({ total: clusters.length, violating: clusters.filter(c => c.hasFailures).length, resources: clusters });
	                    setApplicationPolicySummary({ total: applications.length, violating: applications.filter(a => a.hasFailures).length, resources: applications });
	                    setServicePolicySummary({ total: services.length, violating: services.filter(s => s.hasFailures).length, resources: services });
	                    console.log("Policy Overview Data Processed");
	
	                } catch (e) {
	                    console.error("Error fetching/processing Checkov results:", e);
	                    setCheckovResults([]);
	                    setClusterPolicySummary({ total: 0, violating: 0, resources: [] });
	                    setApplicationPolicySummary({ total: 0, violating: 0, resources: [] });
	                    setServicePolicySummary({ total: 0, violating: 0, resources: [] });
	                }
	            } else {
	                 setCheckovResults([]);
	                 setClusterPolicySummary({ total: 0, violating: 0, resources: [] });
	                 setApplicationPolicySummary({ total: 0, violating: 0, resources: [] });
	                 setServicePolicySummary({ total: 0, violating: 0, resources: [] });
	                 if(integrations && typeof integrations.checkov !== 'undefined') {
	                    console.log("Checkov is not enabled, skipping policy overview update.");
	                 }
	            }
	        };
			const fetchAndProcessKyvernoData = async () => {
				if (integrations?.kyverno?.enabled === true) {
				  console.log("Kyverno enabled, fetching results...");
				  try {
					const data = await queryGraphql(`
						query GetKyvernoResults {
							getKyvernoResults {
								id
								resourceId
								resourceType
								cluster {
									clusterName
									environment
								}
        policies {
          severity
          name
        }
      }
						}
					`, {});
		  
					const results = data?.getKyvernoResults || [];
					setKyvernoResults(results);
					console.log("Kyverno raw results fetched:", results);
		  
					// Process Data for Policy Overview
					const clusters: PolicyResourceStatus[] = [];
		  
					results.forEach((result: any) => {
					  if (result.resourceType === 'cluster' && result.cluster) {
						// Use a more specific fallback prefix
						const id = result.id || result.resourceId || `kyverno-fallback-${Math.random()}`;
						const name = `${result.cluster.clusterName}-${result.cluster.environment}` || `Cluster ${result.resourceId || result.id}`;
						clusters.push({ id, name }); // Note: No 'hasFailures'
					  }
					});
		  
					setKyvernoClusterPolicySummary({ total: clusters.length, resources: clusters });
					console.log("Kyverno Policy Overview Data Processed");
		  
				  } catch (e) {
					console.error("Error fetching/processing Kyverno results:", e);
					setKyvernoResults([]);
					setKyvernoClusterPolicySummary({ total: 0, resources: [] });
				  }
				} else {
				  setKyvernoResults([]);
				  setKyvernoClusterPolicySummary({ total: 0, resources: [] });
				  if (integrations && typeof integrations.kyverno !== 'undefined') {
					console.log("Kyverno is not enabled, skipping policy overview update.");
				  }
				}
			  };
	        if (integrations && typeof integrations.checkov !== 'undefined') {
	           fetchAndProcessCheckovData();
			   fetchAndProcessKyvernoData();
	        }
			else {
				// Optional: Reset states if integrations are cleared or not loaded yet
				setClusterPolicySummary({ total: 0, violating: 0, resources: [] });
				setApplicationPolicySummary({ total: 0, violating: 0, resources: [] });
				setServicePolicySummary({ total: 0, violating: 0, resources: [] });
				setKyvernoClusterPolicySummary({ total: 0, resources: [] });
			  }
	    }, [integrations]);

  React.useEffect(() =>{
    const fetchData = async () => {
      try {
        const data = await queryGraphql(`
           query CostAgent {
              getIntegrations {
                costAgent {
                  datasetId
                  enabled
                  projectId
                  serviceAccountName
                  tableId
                  updatedAt
                }
                checkov {
                  enabled
                }
                kyverno {
                  enabled
                }
                prometheus {
                  enabled
                }
              }
            }
          `, 
            {}
            );
        if(data?.getIntegrations){
         await setIntegrations(data?.getIntegrations);
          console.log(integrations);
        }
        }
        catch(e){
      console.log(e);
        }
  }
  fetchData();
  },[]);

  React.useEffect(() =>{
	const fetchData = async () => {
		try {
			const data = await queryGraphql(`
					query Query($type: String!) {
						bigQueryData(type: $type)
						}
				`, 
					{type: "cluster"}
				  );
			if(data.bigQueryData){
				setBigQueryClusterCost(data?.bigQueryData?.rows[0]?.total_cost_for_label);
			}
			}
			catch(e){
		console.log(e);
			}
}
fetchData();
},[]);

React.useEffect(() =>{
	const fetchData = async () => {
		try {
			const data = await queryGraphql(`
					query Query($type: String!) {
						bigQueryData(type: $type)
						}
				`, 
					{type: "cluster_recent"}
				  );
			if(data.bigQueryData){
				setBigQueryClusterCostRecent(data?.bigQueryData?.rows[0]?.costDifference);
			}
			}
			catch(e){
		console.log(e);
			}
}
fetchData();
},[]);

React.useEffect(() =>{
	const fetchData = async () => {
		try {
			const data = await queryGraphql(`
					query Query($type: String!) {
						bigQueryData(type: $type)
						}
				`, 
					{type: "application"}
				  );
			if(data.bigQueryData){
				setBigQueryApplicationCost(data?.bigQueryData?.rows[0]?.total_cost_for_label);
			}
			}
			catch(e){
		console.log(e);
			}
}
fetchData();
},[]);

React.useEffect(() =>{
	const fetchData = async () => {
		try {
			const data = await queryGraphql(`
					query Query($type: String!) {
						bigQueryData(type: $type)
						}
				`, 
					{type: "application_recent"}
				  );
			if(data.bigQueryData){
				setBigQueryApplicationCostRecent(data?.bigQueryData?.rows[0]?.costDifference);
			}
			}
			catch(e){
		console.log(e);
			}
}
fetchData();
},[]);

React.useEffect(() =>{
	const fetchData = async () => {
		try {
			const data = await queryGraphql(`
					query Query($type: String!) {
						bigQueryData(type: $type)
						}
				`, 
					{type: "service"}
				  );
			if(data.bigQueryData){
				setBigQueryServiceCost(data?.bigQueryData?.rows[0]?.total_cost_for_label);
			}
			}
			catch(e){
		console.log(e);
			}
}
fetchData();
},[]);

React.useEffect(() =>{
	const fetchData = async () => {
		try {
			const data = await queryGraphql(`
					query Query($type: String!) {
						bigQueryData(type: $type)
						}
				`, 
					{type: "service_recent"}
				  );
			if(data.bigQueryData){
				setBigQueryServiceCostRecent(data?.bigQueryData?.rows[0]?.costDifference);
			}
			}
			catch(e){
		console.log(e);
			}
}
fetchData();
},[]);

  let list = navPaneList.filter((e:any) => e.visibility.includes(role)).map((e: any) => e.text);
//   console.log("lstttt",list);
  // console.log(user.roles[0]);
	React.useEffect(() =>{
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query Query {
						resourceStatuses {
							id
							resourceId
							resourceName
							currentStatus
							resourceType
							resourceEnvironment
							resourceOwner {
							id
							name
							googleProfilePicture
							}
							projectUrl
							gcpClusterUrl
							argoCdStaticUrl
							subGroupProjectAppUrl
							subGroupProjectInfraUrl
							createdAt
							updatedAt
						}
						}
					`);
				if(data.resourceStatuses){
					setUpdates(data.resourceStatuses);
					setUpdates((prevData:any) => [...prevData].reverse())
				}
				}
				catch(e){
			console.log(e);
				}
	}
	fetchData();
	},[]);

 	React.useEffect(() =>{
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query{
						services{
						id,
						serviceName,
						framework,
						gcpServiceViewers,
						serviceOwner{
						id,
						name,email,
						googleProfilePicture
						},
						application{
						id,
						applicationName,
						cluster{
						id,
						clusterName,
				}
						},
						createdAt,
						status
						}
				}
					`)
				if(data.services){
					setServices(data.services);
					
				}
				}
					catch(e){
			console.log(e);
		}
	}
	fetchData();
	},[]);

	React.useEffect(() =>{
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query{
                        applications {
						id,
                        applicationName,
						environment,
						status,
						createdAt,
						gcpApplicationViewers,
						applicationOwner{
						id,
						},
						cluster{
						id,
						clusterName,
						},
                        applicationOwner{
						id,
						email,
						name,
						googleProfilePicture
						},
						services{
						id,
						serviceName,
						}
                        }
                        }
					`)
				if(data.applications){
					setApplications(data.applications);
				}
				}
					catch(e){
			console.log(e);
		}
	}
	fetchData();
	},[]);

	React.useEffect(() => {
		(async () => {
			try {
				const data = await queryGraphql(
					`
                       query{
                        clusters {
						id,
                        clusterName,
                        environment,
						status,
						gcpClusterViewers,
						clusterOwner {
							id
							},
						clusterApprover {
							id
							},
						applications {
							id
							applicationName
							status
							environment,
							applicationOwner {
								id
								},
							services {
									serviceName
									id
									status
								}
							}
                        }
                        }
					`
				);
				// console.log(data.clusters);
				if (data.clusters) {
					setClusters(data.clusters);
					
			}
			

			// console.log("Value",clusters.reduce((accumulator : any, cluster : any) => {
          
            //     if (cluster.clusterApprover?.id === user.id) {
            //         return accumulator + cluster.applications.length; 
            //     }
            //     return accumulator; 
            // }, 0))


			// console.log(clusters.reduce((accumulator : any, cluster : any) => {
          
            //     if (cluster.clusterApprover?.id === user.id) {
                   
            //         const clusterServices = cluster.applications.map((application: any) =>
            //             application.services
            //         ).map((service: any) => service); 

            //         return accumulator + clusterServices.length;
            //     }
            //     return accumulator; 
            // }, 0))

			
			// const uniqueClusterIds = Array.from(
			// 	new Set(
			// 	  applications.filter((application :any) => application.applicationOwner.id === user.id) 
			// 		.map((application: any) => application.clusterId)
			// 	)
			//   );
			//   console.log("e",services);

			// console.log("Data",Array.from(new Set (services.filter((service : any) => service.serviceOwner.id == user.id).map((service : any) => service.application.cluster.id))));


		} catch (error) {
				console.log(error);
			}
		})();
	}, []);


	React.useEffect(() => {
		const fetchAiSolutionsCount = async () => {
			try {
				// Define all AI solution queries
				const queries = [
					queryGraphql(`query GetSolutionAIAgents { getSolutionAIAgents { id } }`, {}),
					queryGraphql(`query GetNotebooks { getNotebooks { id } }`, {}),
					queryGraphql(`query GetRAGs { getRAGs { id } }`, {}),
					queryGraphql(`query GetFineTunings { getFineTunings { id } }`, {})
				];

				// Fetch all API calls in parallel for efficiency
				const results = await Promise.all(queries);

				// Extract data from results, providing a fallback empty array
				const agents = results[0]?.getSolutionAIAgents || [];
				const notebooks = results[1]?.getNotebooks || [];
				const rags = results[2]?.getRAGs || [];
				const fineTunings = results[3]?.getFineTunings || [];

				// Sum the lengths of the arrays to get the total count
				const totalAiSolutions = agents.length + notebooks.length + rags.length + fineTunings.length;

				setAiSolutionsCountFromApi(totalAiSolutions);

			} catch (error) {
				console.error("Error fetching AI Solutions count:", error);
				// Set count to 0 if an error occurs
				setAiSolutionsCountFromApi(0);
			}
		};

		fetchAiSolutionsCount();
	}, []); // The empty dependency array ensures this runs only once when the component mounts

	React.useEffect(() => {
		const fetchDataSolutionsCount = async () => {
			try {
				// Define all Data solution queries
				const queries = [
					queryGraphql(`query GetDataWarehouses { getDataWarehouses { id } }`, {}),
					queryGraphql(`query GetDataPipelines { getDataPipelines { id } }`, {}),
					queryGraphql(`query GetDataAnalytics { getDataAnalytics { id } }`, {})
				];

				// Fetch all API calls in parallel
				const results = await Promise.all(queries);

				// Extract data from results, providing a fallback empty array
				const warehouses = results[0]?.getDataWarehouses || [];
				const pipelines = results[1]?.getDataPipelines || [];
				const analytics = results[2]?.getDataAnalytics || [];

				// Sum the lengths of the arrays to get the total count
				const totalDataSolutions = warehouses.length + pipelines.length + analytics.length;

				setDataSolutionsCountFromApi(totalDataSolutions);

			} catch (error) {
				console.error("Error fetching Data Solutions count:", error);
				// Set count to 0 if an error occurs
				setDataSolutionsCountFromApi(0);
			}
		};

		fetchDataSolutionsCount();
	}, []); // The empty dependency array ensures this runs only once

	const PolicyIndicatorSquare = styled(Box)(({ theme }) => ({
		width: '14px',
		height: '14px',
		borderRadius: '3px', // Slightly rounded square
		margin: '2px',
		display: 'inline-block',
		transition: theme.transitions.create(['transform', 'box-shadow'], { // Use theme transitions
			duration: theme.transitions.duration.shorter,
		}),
		cursor: 'pointer',
		flexShrink: 0,
		// Hover effects moved to sx prop where used for dynamic behavior
	}));
	
	const theme = useTheme(); // Get theme for transitions

    // Color constants based on image/common practice
	const passColor = '#12B76A'; // Green
    const failColor = '#F04438'; // Red
    const violatingTextColor = '#D32F2F'; // Darker Red for text
    const iconColor = '#555'; // Slightly darker grey for icons
	const kyvernoColor = '#2196F3'; // <-- ADDED Blue for Kyverno
    // Gradient matching "top to bottom" purple from image
    // Adjust colors and percentages as needed for exact match
    //const headerGradient = 'linear-gradient(to bottom, rgba(220, 206, 240, 0.7) 0%, rgba(237, 231, 246, 0.3) 60%, transparent 100%)';
	const checkovHeaderGradient = 'linear-gradient(to bottom, rgba(220, 206, 240, 0.7) 0%, rgba(237, 231, 246, 0.3) 60%, transparent 100%)';
	//const kyvernoHeaderGradient = 'linear-gradient(to bottom, rgba(255, 237, 224, 0.5) 0%, rgba(255, 245, 238, 0.1) 60%, transparent 100%)';
	// Slightly darker orange gradient
    const kyvernoHeaderGradient = 'linear-gradient(to bottom, rgba(255, 237, 224, 0.7) 0%, rgba(255, 245, 238, 0.3) 60%, transparent 100%)';
	const showPolicyOverview = integrations?.checkov?.enabled || integrations?.kyverno?.enabled; // <-- ADDED conditional flag
    // const headerGradient = 'linear-gradient(90deg, rgba(227, 219, 247, 0.65) 0%, rgba(237, 231, 246, 0.2) 75%, transparent 100%)'; // Alternative from snippet

    // Fallback data to prevent errors if summaries are initially null/undefined
    const safeClusterSummary = clusterPolicySummary || { total: 0, violating: 0, resources: [] };
    const safeAppSummary = applicationPolicySummary || { total: 0, violating: 0, resources: [] };
    const safeServiceSummary = servicePolicySummary || { total: 0, violating: 0, resources: [] };
	const safeKyvernoClusterSummary = kyvernoClusterPolicySummary || { total: 0, resources: [] }; // <-- ADDED Kyverno Safe Summary
	const rolesData= {
		idp_admin:{
			clustersList : clusters.filter((cluster : any) => cluster.status == 'active').length, // He should be able to see all the active clusters 
			applicationsList: clusters?.filter((cluster : any) => cluster?.status == 'active').flatMap((cluster: any) => cluster?.applications?.filter((application: any) => application.status == 'active')).length, // He should be able to see all the active application 
			servicesList: clusters.filter((cluster : any) => cluster.status == 'active').flatMap((cluster : any) => cluster.applications?.filter((application: any) => application.status == 'active').flatMap((application : any )=> application.services?.filter((service: any) => service.status == 'active'))).length // He should be able to see all the active services

		},
		infrastructure_admin:{
			clustersList : clusters.filter((cluster : any) => cluster.status == 'active').length, 
			applicationsList : clusters?.filter((cluster : any) => cluster?.status == 'active').flatMap((cluster?: any) => cluster?.applications?.filter((application: any) => application.status == 'active')).length, 
			// applicationsList : clusters.reduce((accumulator : any, cluster : any) => {
          
            //     if (cluster.clusterApprover?.id === user.id ) {
            //         return accumulator + cluster.applications.length; 
            //     }
            //     return accumulator; 
            // }, 0),

			servicesList : clusters.filter((cluster : any) => cluster.status == 'active').flatMap((cluster : any) => cluster?.applications?.filter((application: any) => application.status == 'active').flatMap((application : any )=> application.services?.filter((service: any) => service.status == 'active'))).length, 
			// servicesList : clusters.reduce((accumulator : any, cluster : any) => { // He should be able to see all the applications for clusters he is the owner 
          
            //     if (cluster.clusterApprover?.id === user.id) {
            //         return accumulator + cluster.applications.reduce((acc : any, application: any) =>{
			// 			return acc + application.services.length;
			// 		},0); 
            //     }
            //     return accumulator; 
            // }, 0),
			
		},
		cluster_owner:{
			clustersList : clusters.filter((cluster : any) => cluster.status == 'active').filter((cluster : any) => cluster.clusterOwner.id == user.id  ).length, // He should be able to see only cluster where he is the owner
			applicationsList : clusters?.filter((cluster : any) => cluster?.status == 'active').reduce((accumulator : any, cluster : any) => { // He should be able to see all the applications for clusters he is the owner 
          
                if (cluster?.clusterOwner?.id === user.id ) {
                    return accumulator + cluster?.applications?.filter((application : any)=> application.status == 'active')?.length; 
                }
                return accumulator; 
            }, 0),
			
			servicesList : clusters.filter((cluster : any) => cluster.status == 'active').reduce((accumulator : any, cluster : any) => { // He should be able to see all the services for clusters he is the owner 
          
                if (cluster.clusterOwner?.id === user.id ) {
                    return accumulator + cluster?.applications?.filter((application : any)=> application.status == 'active').reduce((acc : any, application: any) =>{
						return acc + application?.services?.filter(((service : any)=> service.status == 'active')).length;
					},0); 
                }
                return accumulator; 
            }, 0),
			
		},
		application_owner:{
			clustersList : Array.from(new Set(applications?.filter((application? :any) => application?.status == 'active').filter((application? : any) => application?.applicationOwner?.id == user.id ).map((application? : any) => application?.id))).length,
			applicationsList : applications.filter((application :any) => application.status == 'active').filter((application:any) => application.applicationOwner.id == user.id ).length,
			// servicesList : (applications.filter((application :any) => application.status == 'active').filter((application:any) => application.applicationOwner.id == user.id ).map((application : any) => application.services ? application.services: null )).length,
			servicesList: applications.filter((application: any) => application.status == 'active').filter((application: any) => application.applicationOwner.id == user.id).map((application: any) => application.services ? application.services : null).filter((services: any) => services !== null && services.length > 0).map((services: any) => services.filter((service: any) => service.status === 'active')).reduce((totalService:any, services:any) => totalService + services.length, 0)
			// Make changes for the active services only
		},
		developer:{
			clustersList : Array.from(new Set (services.filter((service : any) => service.status == 'active')?.filter((service : any) => service.serviceOwner.id == user.id )?.map((service : any) => service?.application?.cluster?.id)))?.length,
			applicationsList : Array.from(new Set (services.filter((service : any) => service.status == 'active')?.filter((service : any) => service.serviceOwner.id == user.id )?.map((service : any) => service?.application?.id)))?.length,
			servicesList : services?.filter((service : any) => service.status == 'active').filter((service : any) => service.serviceOwner.id == user.id )?.length,
		}, 
		viewer:{
			clustersList : clusters.filter((cluster : any) => cluster.status == 'active').length, // He should be able to see all the active clusters 
			applicationsList: clusters.filter((cluster : any) => cluster.status == 'active').flatMap((cluster: any) => cluster.applications?.filter((application: any) => application.status == 'active')).length, // He should be able to see all the active application 
			servicesList: clusters.filter((cluster : any) => cluster.status == 'active').flatMap((cluster : any) => cluster.applications?.filter((application: any) => application.status == 'active').flatMap((application : any )=> application.services?.filter((service: any) => service.status == 'active'))).length // He should be able to see all the active services

		},

		
	}

	// const filteredUpdates = {
	// "All": {idp_admin: updates,
	// 	infrastructure_admin: updates,
	// 	cluster_owner: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "cluster" ),
	// 	application_owner: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "application" ),
	// 	developer: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "service" )
	// },
	// "24hrs": {idp_admin: updates.filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 24),
	// 	infrastructure_admin: updates.filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 24),
	// 	cluster_owner: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "cluster" ).filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 24),
	// 	application_owner: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "application" ).filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 24),
	// 	developer: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "service" ).filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 24)
	// },
	// "1hr": {idp_admin: updates.filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 1),
	// 	infrastructure_admin: updates.filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 1),
	// 	cluster_owner: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "cluster" ).filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 1),
	// 	application_owner: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "application" ).filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 1),
	// 	developer: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "service" ).filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 1)
	// },	
	// }

	const filteredUpdates = {
		"All": updates,
		"24hrs": updates.filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 24),
		"1hr": updates.filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 1)		
		}

	const statusStyles = {
		Loading: {
			backgroundImage: 'rgba(253, 176, 34, 1)'
			
		  },
		Success: {
			backgroundImage: 'rgba(18, 183, 106, 0.06)',
			status: ['active','Initiated','Fact File Created','Plan Successful','Cluster Creation Initiated', 'Service Creation Initiated','Cluster Created','Service Creation Completed', 'App Creation Initiated','App Creation Completed','Infra Audit Successful']
		  },
		Error: {
			backgroundImage: 'rgba(240, 68, 56, 0.06)',
			status: ['rejected','Plan Failed','Cluster Creation Failed','GitlabResources Creation Failed','App Creation Failed','Infra Audit Failed'],
		  },
		Pending: {
			backgroundImage: 'rgba(248, 248, 248, 1)',
			status: ['pending','MR Approval Pending'],
		  },
	  
	  }

	function convertUnixTimeToDate(unixTimestamp : any) {
		const timestamp = Number(unixTimestamp);
		const date = new Date(timestamp);
		const formattedDate = date.toLocaleString('en-GB', { 
		day: '2-digit',
		month: '2-digit',
		year: 'numeric'
		});

		return formattedDate;
	  }
	function convertUnixToISO(unixTimestamp : any) {
		const timestamp = Number(unixTimestamp);
		try {
		  const date = new Date(timestamp);
		  return date.toISOString();
		} catch (error) {
		  console.error("Invalid Unix timestamp:", error);
		  return "Invalid Date";
		}
	  }
	//   This function helps us to get the difference between two unix timestamps in hours
	function timeDifference(timeA:any, timeB: any){
		let timeStampA = new Date(convertUnixToISO(timeA));
		let timeStampB = new Date(convertUnixToISO(timeB));

		const differenceMilliseconds = timeStampA.getTime() - timeStampB.getTime();
		const differenceMinutes = (differenceMilliseconds / (60*60*1000));
		return differenceMinutes;
	}
	const getInitialDrawerState = () => {
			if (typeof window !== 'undefined') {
				const storedState = localStorage.getItem('isFaradayDrawerOpen');
				return storedState !== null ? JSON.parse(storedState) : true;
			}
			return true;
		};
		const [isDrawerActuallyOpen, setIsDrawerActuallyOpen] = useState<boolean>(getInitialDrawerState);
	
		const handleDrawerStateChange = (isOpenFromDrawer: boolean) => {
			setIsDrawerActuallyOpen(isOpenFromDrawer);
		};
	
//   const aiSolutionsCount = 5; // Static value
//   const dataSolutionsCount = 7; // Static value
  // Style object for react-icons
  const iconStyles = { color: '#333333',height:"14px", width:"14px" };

// console.log("updates",updates);
// --- START: Observability Section Data ---
    const totalResources = 13;
    const healthyResources = 13;
    const unhealthyResources = 0;

    const observabilityChartData = {
        datasets: [{
            data: [healthyResources, unhealthyResources],
            backgroundColor: ['#0064FF', '#FDB022'], // Blue and Yellow/Orange
            borderColor: '#FFFFFF',
			borderWidth: 8,
            borderRadius: 20,
            cutout: '83%',
        }],
    };

    const observabilityChartOptions = {
        plugins: {
            tooltip: { enabled: false },
            legend: { display: false },
        },
        maintainAspectRatio: false,
    };

    // --- HARDCODED DATA for Cost Overview ---
    const HARDCODED_COST_DATA = [
        { label: 'Clusters', cost: 51826, change: 12, color: '#2B7FFF' },
        { label: 'Applications', cost: 40470, change: 6, color: '#FFAE4C' },
        { label: 'Services', cost: 7426, change: 6, color: '#6FD195' },
        { label: 'AI Solutions', cost: 20101, change: -9, color: '#07DBFA' },
        { label: 'Data Solutions', cost: 10136, change: 31, color: '#F4A79D' },
    ];

    // --- HARDCODED DATA for Resource Overview ---
    const HARDCODED_RESOURCE_COUNTS = {
        clusterCount: 2,
        appCount: 4,
        serviceCount: 3,
        aiSolutionsCount: 5,
        dataSolutionsCount: 2
    };

    // --- HARDCODED DATA for Security Overview ---
    const HARDCODED_SECURITY_STATS = {
        checkov: {
            byResourceType: {
                cluster: { total: 2, passed: 27, failed: 2, topFailing: ['axios'] },
                application: { total: 4, passed: 36, failed: 4, topFailing: ['cipher', 'vertex', 'cortex'] },
                service: { total: 3, passed: 6, failed: 0, topFailing: [] },
            },
            totalPolicyChecks: 75,
        },
        kyverno: {
            cluster: { total: 2, policiesEnforced: 22, topHighSeverity: ['futurify', 'axios'] },
            totalPolicyChecks: 22,
        }
    };
    //  const clusterCount = rolesData[role]?.clustersList ?? 0;
  // const appCount = rolesData[role]?.applicationsList ?? 0;
  // const serviceCount = rolesData[role]?.servicesList ?? 0;
  const [aiSolutionsCountFromApi, setAiSolutionsCountFromApi] = useState<number>(0);
  const [dataSolutionsCountFromApi, setDataSolutionsCountFromApi] = useState<number>(0);
  const {
        clusterCount,
        appCount,
        serviceCount,
        aiSolutionsCount,
        dataSolutionsCount
     } = USE_HARDCODED_DATA ? HARDCODED_RESOURCE_COUNTS : {
        clusterCount: rolesData[role]?.clustersList ?? 0,
        appCount: rolesData[role]?.applicationsList ?? 0,
        serviceCount: rolesData[role]?.servicesList ?? 0,
        aiSolutionsCount: aiSolutionsCountFromApi,
        dataSolutionsCount: dataSolutionsCountFromApi
     };

    // --- END: Observability Section Data ---
	  return (
		<Box sx={{ display: "flex" }}>
			{isDrawerActuallyOpen && (
                <MainDrawer
                // Assuming "integrations" is the correct index for Kyverno page
                // If Kyverno has its own top-level menu item, update this index.
                index={"overview"} // Or a more specific index like "integrations-kyverno" if applicable            
                onStateChange={handleDrawerStateChange}
            />
            )}
            {!isDrawerActuallyOpen && (
                <MainDrawer
                // Assuming "integrations" is the correct index for Kyverno page
                // If Kyverno has its own top-level menu item, update this index.
                index={"overview"} // Or a more specific index like "integrations-kyverno" if applicable
                onStateChange={handleDrawerStateChange}
            />
            )}
			<MiniBot/>
			<Box sx={{
					flex: 1,
					bgcolor: "#fafafa",
					minHeight: window.innerHeight,
				}}>
			<Box bgcolor="#FFFFFF" pb={2} pt={2} mb={0}>

		
			            <Box
										sx={{
											display: "flex",
											justifyContent: "space-between",
											alignItems: "center",
											marginBottom: 0,
											mx: 4,
										}}
									>
										<Typography fontSize="22px" gutterBottom fontFamily="Gilroy-Bold" color="#333333">
											Overview
										</Typography>
                    
                   
								<Box sx={{display:'flex', justifyContent:'center'}}>
                                  <Button
                                          variant="contained"
                                          color="primary"
                                          sx={{
                                            backgroundColor: "black",
                                            color: "white",
                                            padding: "8px 24px",
                                            fontSize: "0.875rem",
                                            textTransform: "none",
                                            display: 'flex', // To align the arrow icon with the text
                                            alignItems: 'center',
                                          }}
                                          id="go-to-button"
										  disabled={isViewer}
                                          aria-controls={open ? 'go-to-menu' : undefined}
                                          aria-haspopup="true"
                                          aria-expanded={open ? 'true' : undefined}
                                          onClick={handleClick}
                                        >
                                          <Typography fontSize="14px" fontFamily="Gilroy-Bold">
                                            Add new
                                          </Typography>
                                          <ArrowForwardIosOutlined sx={{ml: 1, fontSize:"14px"}} />
                                        </Button>
											<IconButton
          aria-label="Help" 
          onClick={()=> window.open(`${process.env.REACT_APP_HOST_DOMAIN}/docs` , "_blank")}
          sx={{
            padding: 0, 
            border: 'none',  
			ml:2,
            '&:hover': {
              
              backgroundColor: 'action.hover', 
            },
            
          }}
        >
          <Box
            component="img"
            src="/assets/Help.svg" 
            alt="" 
            sx={{
              width: 40,  
              height: 40,
              display: 'block', 
            }}
          />
        </IconButton>
                                        <Menu
                                          id="go-to-menu"
                                          anchorEl={anchorEl}
                                          open={open}
                                          onClose={handleClose}
                                          MenuListProps={{
                                            'aria-labelledby': 'go-to-button',
                                          }}
                                        >
                                          {navPaneList.filter((e:any)=> e.visibility.includes(role) ).map((option:any) => (
                                            <MenuItem key={option.value} onClick={(e:any) => navigate(option.nav)}>
                                              {option.icon}
                                              <Typography fontFamily="Gilroy-Medium" ml={1}>
                                                {option.text}
                                              </Typography>
                                            </MenuItem>
                                          ))}
                                        </Menu>
                              
										 </Box>
		
									</Box>

								

									</Box>
									

                  {/* <Box mx={2} sx={{backgroundColor: '#FFFFFF'}} >
										<Card elevation={0}>
											<CardContent>
				
				</CardContent>
				</Card>
				</Box> */}
	  <Box sx={{display:"flex"}} >

			 
				<LeftBox>
          <Box sx={{backgroundColor:"#FFFFFF", mb:2}}>
				<Typography fontSize="18px" fontFamily="Gilroy-Bold" color="#333333" mx={4}  pb={1} pt={1}>
											Hello, {user.name}!
				</Typography>
        </Box>

									<Box >
									
									<Link to="/finops-dashboard" style={{ textDecoration: 'none' }}>
    {integrations?.costAgent?.enabled === true && (
        // This parent Box creates a "canvas" for the background image and content.
        <Box
            mx={2}
            my={2}
            sx={{
              
                position: 'relative', // Needed for absolute positioning of children
                borderRadius: 2,
                overflow: 'hidden', // Ensures the image corners are also rounded
                color: 'inherit',
                '&:hover': {
                    // Apply hover effect to a semi-transparent overlay for better results
                    '& .hover-overlay': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    }
                },
            }}
        >
            {/* This is the background image tag */}
            <Box
                component="img"
                // IMPORTANT: Replace this with the actual path to your background image.
                src="/assets/cost-overview-dashboard-bg.svg"
                alt="Background"
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover', // Ensures the image covers the entire area
                    zIndex: 0,
                }}
            />

            {/* This overlay improves the hover effect on a dark image */}
            

            {/* This Box now holds your content, safely on top of the background image */}
            <Box
                sx={{
                    position: 'relative', // Ensures this content is above the background
                    zIndex: 2,
                    px: "16px", py:"16px",
                }}
            >
                {(() => {
                    // --- Data Configuration ---
                    const costData = USE_HARDCODED_DATA ? HARDCODED_COST_DATA :[
                        {
                            label: 'Clusters',
                            cost: bigQueryClusterCost || 0,
                            change: bigQueryClusterCostRecent || 0,
                            color: '#2B7FFF', // Blue
                        },
                        {
                            label: 'Applications',
                            cost: bigQueryApplicationCost || 0,
                            change: bigQueryApplicationCostRecent || 0,
                            color: '#FFAE4C', // Orange
                        },
                        {
                            label: 'Services',
                            cost: bigQueryServiceCost || 0,
                            change: bigQueryServiceCostRecent || 0,
                            color: '#6FD195', // Green
                        },
						{
                            label: 'AI Solutions',
                            //cost: bigQueryServiceCost || 0,
							cost:1784,
                            //change: bigQueryServiceCostRecent || 0,
							change:127,
                            color: '#07DBFA', 
                        },
						{
                            label: 'Data Solutions',
                            //cost: bigQueryServiceCost || 0,
							cost:1358,
                            //change: bigQueryServiceCostRecent || 0,
							change:-79,
                            color: '#F4A79D', 
                        },
                    ];

                    // --- Logical Calculations ---
                    const totalCost = costData.reduce((sum, item) => sum + item.cost, 0);
                    const totalChange = costData.reduce((sum, item) => sum + item.change, 0);

                    // --- Chart Configuration ---
                    const chartData = {
                        datasets: [
                            {
                                data: costData.map(item => item.cost),
                                backgroundColor: costData.map(item => item.color),
                                borderWidth: 3,
                                borderRadius: 10,
                                borderColor: '#101010',
                                cutout: '87%',
                            },
                        ],
                    };
                    const chartOptions = {
                        plugins: { tooltip: { enabled: false }, legend: { display: false } },
                        maintainAspectRatio: false,
                    };

                    // --- Helper Component for List Items (WITH TYPES AND IMAGE ICON) ---
                    type CostListItemProps = {
                        label: string;
                        cost: number;
                        change: number;
                        color: string;
                    };

                    const CostListItem = ({ label, cost, change, color }: CostListItemProps) => (
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Box sx={{ width: 14, height: 14, borderRadius: '50%', backgroundColor: color }} />
                                <Typography fontFamily="Gilroy-Medium" fontSize="14px" color="#E6E6E6">
                                    {label}
                                </Typography>
                            </Box>
                            <Box sx={{ textAlign: 'right' }}>
                                <Typography fontFamily="Gilroy-Bold" fontSize="14px" color="#FFFFFF">
                                    ₹ {Math.round(cost).toLocaleString('en-US')}
                                </Typography>
                                <Typography
                                    fontFamily="Gilroy-Medium"
                                    fontSize="10px"
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        color: change >= 0 ? "#F04438" : "#12B76A",
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <img
                                        src={change >= 0 ? "/assets/arrow-up-red.svg" : "/assets/arrow-down-green.svg"}
                                        alt={change >= 0 ? "Increase" : "Decrease"}
                                        style={{ width: 12, height: 12, marginRight: '4px' }}
                                    />
                                    ₹ {Math.abs(Math.round(change)).toLocaleString('en-US')} from last month
                                </Typography>
                            </Box>
                        </Box>
                    );

                    return (
                        <Box>
                            {/* HEADING ADDED HERE */}
                            <Typography fontFamily="Gilroy-Bold" fontSize="18px" color="#FFFFFF" sx={{ mb: 1 }}>
                                Cost Overview
                            </Typography>
                            
                            {/* This container now centers the group and sets a fixed gap */}
                            <Box sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center',
                                gap: 10 // Sets a fixed 120px gap between the chart and the list
                            }}>
                                {/* Left Side: Pie Chart */}
                                <Box sx={{ position: 'relative', width: 250, height: 250, flexShrink: 0 }}>
                                    <Doughnut data={chartData} options={chartOptions} />
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            textAlign: 'center',
                                        }}
                                    >
                                        <Typography fontFamily="Gilroy-Regular" fontSize="14px" color="#E6E6E6">
                                            Total Cost
                                        </Typography>
                                        <Typography fontFamily="Gilroy-Bold" fontSize="26px" color="#FFFFFF" sx={{ my: 0.5 }}>
                                            ₹ {Math.round(totalCost).toLocaleString('en-US')}
                                        </Typography>
                                        <Typography
                                            fontFamily="Gilroy-Medium"
                                            fontSize="12px"
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                color: totalChange >= 0 ? "#F04438" : "#12B76A",
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <img
                                                src={totalChange >= 0 ? "/assets/arrow-up-red.svg" : "/assets/arrow-down-green.svg"}
                                                alt={totalChange >= 0 ? "Increase" : "Decrease"}
                                                style={{ width: 12, height: 12, marginBottom:'20px'}}
                                            />
                                            ₹ {Math.abs(Math.round(totalChange)).toLocaleString('en-US')} from last month
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Right Side: Cost Breakdown List */}
                                <Box sx={{
                                    width: '100%', // Set a width for the list container
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between', 
                                    fontSize:'14px',
                                }}>
                                    {costData.map((item, index) => (
                                        <React.Fragment key={item.label}>
                                            <CostListItem {...item} />
                                            {index < costData.length - 1 && (
                                                <Divider sx={{ 
                                                    borderColor: '#313131', 
                                                    my: 1
                                                }} />
                                            )}
                                        </React.Fragment>
                                    ))}
                                </Box>
                            </Box>
                        </Box>
                    );
                })()}
            </Box>
        </Box>
    )}
</Link>
									
									
							<Box mx={2}>
      <Card
        elevation={0}
        sx={{
          borderRadius: "12px",
          width: '100%',
          position: 'relative', // Needed to position the background image
          overflow: 'hidden', // Ensures the image respects the border radius
        }}
      >
        {/* Background Image Tag */}
        <img
          src='/assets/resource-overview-dashboard-bg.svg' // Placeholder background image
          alt="Abstract background"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '53vw',
            height: '10vh',
            objectFit: 'cover',
            zIndex: 0, // Place image behind the content
          }}
        />
        <CardContent sx={{ px: "16px", py:"16px", position: 'relative', zIndex: 1 }}>
          <Typography fontFamily="Gilroy-Bold" fontSize="18px" mb="10px">
            Resource Overview
          </Typography>

          {/* Inner Box for metrics with its own background */}
          <Box sx={{
            backgroundColor: '#F9FBFC',
            borderRadius: '8px',
            p: 3,
            //boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          }}>
            <Box sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around', // Distribute items evenly
              alignItems: 'center',
              width: '100%'
            }}>
              <MetricItem
                icon={<RiArchiveDrawerLine style={iconStyles} />}
                value={clusterCount}
                label={`Cluster${clusterCount !== 1 ? 's' : ''}`}
              />

              <Divider orientation="vertical" flexItem sx={{ mx: 1, color:'#E4E7EC' }} />

              <MetricItem
                icon={<RiArchiveStackLine style={iconStyles} />}
                value={appCount}
                label={`Application${appCount !== 1 ? 's' : ''}`}
              />

              <Divider orientation="vertical" flexItem sx={{ mx: 1, color:'#E4E7EC' }} />

              <MetricItem
                icon={<RiBubbleChartLine style={iconStyles} />}
                value={serviceCount}
                label={`Service${serviceCount !== 1 ? 's' : ''}`}
              />

              <Divider orientation="vertical" flexItem sx={{ mx: 1, color:'#E4E7EC' }} />

              <MetricItem
                icon={<RiAiGenerate style={iconStyles} />}
                value={aiSolutionsCount}
				label={`AI Solution${aiSolutionsCount !== 1 ? 's' : ''}`}
                //label={'AI Solutions'}
              />

              <Divider orientation="vertical" flexItem sx={{ mx: 1, color:'#E4E7EC' }} />

              <MetricItem
                icon={<RiLineChartLine style={iconStyles} />}
                value={dataSolutionsCount}
				label={`Data Solution${dataSolutionsCount !== 1 ? 's' : ''}`}
                //label={'Data Solutions'}
              />
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>		
										
										{showPolicyOverview && (() => {
    // Determine which stats to display based on the selected tool and resource type
    const finalSecurityStats = USE_HARDCODED_DATA ? HARDCODED_SECURITY_STATS : securityStats;
    const isCheckov = selectedTool === 'checkov';
    const checkovData = finalSecurityStats.checkov.byResourceType[selectedResourceType as keyof typeof finalSecurityStats.checkov.byResourceType];
    const kyvernoData = finalSecurityStats.kyverno.cluster;

    const currentStats = isCheckov ? checkovData : kyvernoData;
    const totalChecks = isCheckov ? finalSecurityStats.checkov.totalPolicyChecks : finalSecurityStats.kyverno.totalPolicyChecks;
    const resourceName = isCheckov ? selectedResourceType : 'cluster';
    const resourceNameCapitalized = resourceName.charAt(0).toUpperCase() + resourceName.slice(1);
    
    const backgroundImage = isCheckov ? '/assets/checkov-background.svg' : '/assets/kyverno-background.svg';
    const checkovIcon = isCheckov ? '/assets/checkov-selected.svg' : '/assets/checkov-unselected.svg';
    const kyvernoIcon = isCheckov ? '/assets/kyverno-unselected.svg' : '/assets/kyverno-selected.svg';


    const chartData: ChartData<'bar'> = {
        labels: [''],
       datasets: isCheckov ? [
    {
        label: 'Passed',
        data: [checkovData.passed],
        backgroundColor: '#0064FF',
        borderRadius: 8,
		categoryPercentage: 0.5, // Narrows the space for the bar group
        barPercentage: 0.5       // Uses 80% of that narrow space for the bar
    },
    {
        label: 'Failed',
        data: [checkovData.failed],
        backgroundColor: '#FDB022',
        borderRadius: 8,
        categoryPercentage: 0.5, // Narrows the space for the bar group
        barPercentage: 0.5       // Uses 80% of that narrow space for the bar
    },
] : [
    {
        label: 'Policies Enforced',
        data: [kyvernoData.policiesEnforced],
        backgroundColor: '#0064FF',
        borderRadius: 8,
        categoryPercentage: 0.25,
        barPercentage: 0.5
    },
],
    };

    return (
        <Box mx={2} my={2}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Card sx={{ borderRadius: "16px", height: '100%', position: 'relative', overflow: 'hidden', boxShadow: 'none', border: `1px solid ${theme.palette.divider}` }}>
                        <Box
                            component="img"
                            src={backgroundImage}
                            alt="background"
                            sx={{
                                position: 'absolute', top: 0, left: 0, right: 0,
                                width: '100%', height: '100vh', objectFit: 'cover',
                                zIndex: 1, opacity:1
                            }}
                        />
                        <CardContent sx={{ px: "16px", py:"16px", position: 'relative', zIndex: 2 }}>
                            <Typography fontFamily="Gilroy-Bold" fontSize="18px" color='#232324' sx={{ mb: 1 }}>
                                Security Overview
                            </Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography fontFamily="Gilroy-Bold" fontSize="16px" color="#333333" sx={{ lineHeight: 1.5 }}>
                                    {isCheckov ? 'Checkov' : 'Kyverno'}
                                    <br />
                                    <Box 
                                        component="span" 
                                        sx={{ 
                                            fontFamily: 'Gilroy-Regular', 
                                            fontSize: '12px', 
                                            color: '#333333' 
                                        }}
                                    >
                                        {totalChecks} policy check{totalChecks === 1 ? '' : 's'} executed
                                    </Box>
                                </Typography>
                                <Stack direction="row" spacing={1.5} sx={{ background: '#FFFFFF', p: '1px', borderRadius: '70px', }}>
                                    <ToolIconButton selected={isCheckov} onClick={() => setSelectedTool('checkov')}>
                                        <img src={checkovIcon} alt="Checkov" style={{ width: 32, height: 32 }} />
                                    </ToolIconButton>
                                    <ToolIconButton selected={!isCheckov} onClick={() => setSelectedTool('kyverno')}>
                                        <img src={kyvernoIcon} alt="Kyverno" style={{ width: 32, height: 32 }} />
                                    </ToolIconButton>
                                </Stack>
                            </Box>

                            {isCheckov ? (
    <Select
        value={selectedResourceType}
        onChange={(e) => setSelectedResourceType(e.target.value)}
        fullWidth
        sx={{
            borderRadius: '6px', fontFamily: 'Gilroy-Medium', mb: 3, height:'44px',
            backgroundColor:'#FFFFFF', fontSize:'14px',
            '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
            '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
            '& .MuiSelect-select': { paddingRight: '32px', color: '#333333' },
        }}
        IconComponent={CustomDropdownIcon}
    >
        <MenuItem value="cluster">Clusters</MenuItem>
        <MenuItem value="application">Applications</MenuItem>
        <MenuItem value="service">Services</MenuItem>
    </Select>
) : (
    // This empty Box reserves the space of the dropdown
    <Box sx={{ height: '44px', mb: 3 }} />
)}

                            <Typography fontFamily="Gilroy-Regular" fontSize="12px" color="#666666">Total {resourceNameCapitalized}s</Typography>
                            <Typography fontFamily="Gilroy-Bold" fontSize="28px" color="#333333" sx={{ mb: 2 }}>{currentStats.total}</Typography>

                            {isCheckov && checkovData.topFailing.length > 0 && (
                                <>
                                    <Typography fontFamily="Gilroy-Medium" fontSize="14px" sx={{ mb: 1 }}>Top 3 {resourceNameCapitalized}s with most failed checks</Typography>
                                    <Stack direction="row" spacing={1} sx={{ mb: 3, flexWrap: 'wrap', gap: 1 }}>
                                        {checkovData.topFailing.map((item: string) => <Chip key={item} label={item} sx={{ fontFamily: 'Gilroy-Regular', color:'#333333', fontSize:'14px', borderRadius: '24px', bgcolor:'#FAFAFA', border:'1px solid #E6E6E6' }} />)}
                                    </Stack>
                                </>
                            )}
							{/* --- ADD THIS NEW BLOCK --- */}
{!isCheckov && kyvernoData.topHighSeverity.length > 0 && (
    <>
        <Typography fontFamily="Gilroy-Medium" fontSize="14px" sx={{ mb: 1 }}>Top 3 Clusters with High Severity Policies</Typography>
        <Stack direction="row" spacing={1} sx={{ mb: 3, flexWrap: 'wrap', gap: 1 }}>
            {kyvernoData.topHighSeverity.map((item: string) => <Chip key={item} label={item} sx={{ fontFamily: 'Gilroy-Regular', color:'#333333', fontSize:'14px', borderRadius: '24px', bgcolor:'#FAFAFA', border:'1px solid #E6E6E6' }} />)}
        </Stack>
    </>
)}
{/* --- END OF NEW BLOCK --- */}

                            <Box sx={{ height: 220, width: '100%' }}>
                               
<Bar 
    data={chartData} 
    options={{ 
        responsive: true, 
        maintainAspectRatio: false, 
        plugins: { legend: { display: false } }, 
        scales: { 
            y: { beginAtZero: true, grid: { drawOnChartArea: false, } }, 
            x: { grid: { display: false } } 
        } 
    }} 
/>
                            </Box>
                            
                            {/* --- CHANGE 2: Updated Legend Layout --- */}
                            <Box sx={{ mt: 2, p: 2, bgcolor: '#F9FAFB', borderRadius: '8px' }}>
                                {isCheckov ? (
                                    <Stack spacing={1.5}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Box sx={{ width: 16, height: 16, bgcolor: '#0064FF', borderRadius: '50%', mr: 1 }} />
                                                <Typography fontFamily="Gilroy-Medium" fontSize="12px" color="#232324">Passed</Typography>
                                            </Box>
                                            <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" color="#232324">{checkovData.passed}</Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Box sx={{ width: 16, height: 16, bgcolor: '#FDB022', borderRadius: '50%', mr: 1 }} />
                                                <Typography fontFamily="Gilroy-Medium" fontSize="12px" color="#232324">Failed</Typography>
                                            </Box>
                                            <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" color="#232324">{checkovData.failed}</Typography>
                                        </Box>
                                    </Stack>
                                ) : (
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Box sx={{ width: 16, height: 16, bgcolor: '#0064FF', borderRadius: '50%', mr: 1 }} />
                                            <Typography fontFamily="Gilroy-Medium" fontSize="12px" color="#232324">Policies Enforced</Typography>
                                        </Box>
                                        <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" color="#232324">{kyvernoData.policiesEnforced}</Typography>
                                    </Box>
                                )}
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
               {/* --- START: CORRECTED OBSERVABILITY OVERVIEW SECTION --- */}
<Grid item xs={12} md={6}>
    {/* The main Card component still fills the available height */}
    <Card sx={{ borderRadius: "16px", height: '100%', display: 'flex', flexDirection: 'column', border: `1px solid ${theme.palette.divider}`, boxShadow: 'none' }}>
        <CardContent sx={{ p: "16px", display: 'flex', flexDirection: 'column', flexGrow: 1 }}>

            {/* --- Header Content (No Changes Here) --- */}
            <Box>
                <Typography fontFamily="Gilroy-Bold" fontSize="18px" color="#333333">
                    Observability Overview
                </Typography>
                <Box sx={{ 
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    p: 1.5, my: 2, border: '1px solid #FDB022',
                    borderRadius: '8px', backgroundColor: '#FFFAEB', cursor: 'pointer'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <RiErrorWarningLine color="#FDB022" size="20px" />
                        <Typography fontFamily="Gilroy-Medium" fontSize="14px" color="#232324" sx={{ ml: 1 }}>
                            <b>0 clusters</b> with critical health needs attention
                        </Typography>
                    </Box>
                    {/* <ArrowForwardIosIcon sx={{ fontSize: '16px', color: '#B54708' }}/> */}
                </Box>
            </Box>
            
            {/* --- Chart Container (This is where the fix is applied) --- */}
            {/* This outer Box grows to fill the space and sets a positioning context */}
            <Box sx={{ flexGrow: 1, position: 'relative' }}>
                {/* This new inner Box is absolutely positioned to isolate the chart */}
                <Box sx={{ position: 'absolute', top: 50, left: 50, width: '80%', height: '80%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Doughnut data={observabilityChartData} options={observabilityChartOptions} />
                    <Box sx={{ position: 'absolute', textAlign: 'center' }}>
                        <Typography fontFamily="Gilroy-Medium" fontSize="14px" color="#666666">
                            Total Resources
                        </Typography>
                        <Typography fontFamily="Gilroy-Bold" fontSize="28px" color="#333333">
                            {totalResources}
                        </Typography>
                    </Box>
                </Box>
            </Box>
            
            {/* --- Legend (No Changes Here) --- */}
            <Box sx={{ mt: 2, p: 2, bgcolor: '#F9FAFB', borderRadius: '8px' }}>
                <Stack spacing={1.5}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ width: 16, height: 16, bgcolor: '#0064FF', borderRadius: '50%', mr: 1 }} />
                            <Typography fontFamily="Gilroy-Medium" fontSize="12px" color="#232324">Healthy ({">"}75%)</Typography>
                        </Box>
                        <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" color="#232324">{healthyResources}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ width: 16, height: 16, bgcolor: '#FDB022', borderRadius: '50%', mr: 1 }} />
                            <Typography fontFamily="Gilroy-Medium" fontSize="12px" color="#232324">Unhealthy ({"<"}75%)</Typography>
                        </Box>
                        <Typography fontFamily="Gilroy-SemiBold" fontSize="14px" color="#232324">{unhealthyResources}</Typography>
                    </Box>
                </Stack>
            </Box>

        </CardContent>
    </Card>
</Grid>
{/* --- END: CORRECTED OBSERVABILITY OVERVIEW SECTION --- */}
            </Grid>
        </Box>
    )
})()}
	
										<Box mx={2}  my={2} sx={{maxHeight:'80vh',overflowY: "auto"}}>
											<Card elevation={0} sx={{borderRadius:'16px'}}>
												<CardContent sx={{p:'16px'}}>
													<Typography fontFamily="Gilroy-Bold" fontSize="18px" gutterBottom>Knowledge Bank</Typography>
													{knowledgeBankData.map((item, index) => (
														
														<Box key={index} sx={{cursor: 'pointer' }} onClick={() => {window.open(item.url, '_blank', 'noopener noreferrer')}} >
														<Box  marginY={1} sx={{display: 'flex', }}>
														  {item.image && ( 
															<Box sx={{ width: '25%'}} >
															  <CardMedia
																component="img"
																image={item.image}
																alt={item.title}
																sx={{ width:'100%', height: '10vh', borderRadius:"8px" , display: "flex", alignContent: "center", justifyContent: "center", '& img': {objectFit: 'contain' }}}
															  />
															</Box>
														  )}
														  <Box ml={2} sx={{ width: '73%' }}>
															
															<Box justifyContent="flex-start" alignItems="center" marginBottom={1}>
		
																<Typography px={1} py={0.75} marginBottom={1} fontFamily="Gilroy-Light" fontSize="12px" sx={{backgroundColor:'#F7F6F6', borderRadius:1, whiteSpace: 'nowrap',display: 'inline'}}>{item.author.toUpperCase()} | {item.date}</Typography>
															</Box>
															<Box justifyContent="flex-start" alignItems="center" >
															<Typography fontFamily="Gilroy-Bold" fontSize="14px" align="justify" sx={{overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical',  marginBottom:1 }}>{item.title}</Typography>
															
															<Typography fontFamily="Gilroy-Medium" fontSize="12px" align="justify" sx={{overflow: 'hidden', textOverflow: 'ellipsis',display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', marginBottom:1 }}>{item.content}</Typography>
															</Box>
															
														  </Box>
														  
														</Box>
														<Divider/>
													  </Box>
													  
													))}
												</CardContent>
											</Card>
										</Box>
										
										<Box mx={2}  my={2}>
												<Card elevation={0} sx={{borderRadius:'16px'}}>
												<Box sx={{maxHeight:'80vh',overflowY: "auto"}}>
											<CardContent sx={{p:'16px'}}>
											<Typography fontFamily="Gilroy-Bold" fontSize="18px" gutterBottom>Frequently Asked Questions</Typography>
												{/* Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora iusto praesentium odio ipsam! Aperiam cumque recusandae omnis? Maiores, sequi totam harum aperiam illo eligendi placeat sapiente minus deserunt repellendus, distinctio incidunt provident ducimus quibusdam minima laboriosam molestias, reiciendis explicabo ad eum inventore consequuntur? Laborum quasi distinctio repellendus. Quasi consequuntur blanditiis neque debitis ullam, nostrum dignissimos deleniti! */}
											
												<Box display="flex" gap={2} mt="14px">
																											<Button
																												sx={{
																													borderRadius: 5,
																													borderColor: questionsType == "general" ? "#000000" : "#666666",
																													color: questionsType == "general" ? "#000000" : "#666666",
																													bgcolor: questionsType == "general" ? "#E0E0E0" : "#FFFFFF",
																													textTransform: "none",
																												}}
																												variant="outlined"
																												
																												onClick={() => setQuestionsType('general')}
																												
																											>
																												General
																											</Button>

																											<Button
																												sx={{
																													borderRadius: 5,
																													borderColor: questionsType == "cluster" ? "#000000" : "#666666",
																													color: questionsType == "cluster" ? "#000000" : "#666666",
																													bgcolor: questionsType == "cluster" ? "#E0E0E0" : "#FFFFFF",
																													textTransform: "none",
																												}}
																												variant="outlined"
																												
																												onClick={() => setQuestionsType('cluster')}
																												
																											>
																												Cluster
																											</Button>
																											<Button
																												sx={{
																													borderRadius: 5,
																													borderColor: questionsType == "application" ? "#000000" : "#666666",
																													color: questionsType == "application" ? "#000000" : "#666666",
																													bgcolor: questionsType == "application" ? "#E0E0E0" : "#FFFFFF",
																													textTransform: "none",
																													
																												}}
																												variant="outlined"
																												
																												onClick={() => setQuestionsType('application')}
																											
																											>
																												Application
																											</Button>
																											<Button
																												sx={{
																													borderRadius: 5,
																													borderColor: questionsType == "service" ? "#000000" : "#666666",
																													color: questionsType == "service" ? "#000000" : "#666666",
																													bgcolor: questionsType == "service" ? "#E0E0E0" : "#FFFFFF",
																													textTransform: "none",
																												}}
																												variant="outlined"
																									
																												onClick={() => setQuestionsType('service')}
																												
																											>
																												Service
																											</Button>
																										</Box>


											
												{questionsType? (
													<>
													{questions[qt].map((item:any,index:any) =>
													(
														<Box key={index} mb={0}>
														
											<Accordion
												elevation={0}
												sx={{
													borderRadius: "8px",
													
													"&:before": {
														mb: "2px",
														display: "none",
													},
													bgcolor: "white",
													
													"& .MuiAccordionSummary-root": { 
														padding: "0.5vh 0.5vh", 
													},
													"& .MuiAccordionDetails-root": { 
														padding: "0.5vh 0.5vh 0.5vh", 
													},
												}}
											>
												<AccordionSummary sx={{py:0}} expandIcon={<ExpandMore />}>
												<Typography fontFamily="Gilroy-Bold" fontSize="14px" >{item.question}</Typography>
												</AccordionSummary>
												<AccordionDetails sx={{mt:0}}>
													
													<Typography fontFamily="Gilroy-Medium" fontSize="12px">{item.answer}</Typography>
												</AccordionDetails>
												
											</Accordion>
											<Divider  />
														</Box>
													)
													)}
													</>
												): <>false statement</> 

												}
											</CardContent>
											</Box>
										</Card>
										</Box>
										
									</Box>
									
								
        </LeftBox>
        <RightBox>
				
			
					<Box>

					<Card elevation={0} sx={{   height:"30vh"}}  >
					
					<iframe
        width="100%"
        height="100%" 
        src="https://www.youtube.com/embed/dFFe_aORDs0?si=UODZ2VpjL3KEBvmv"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock"
      />

{/* <iframe
        src="https://faraday.searce.com" 
        width="800"
        height="600" 

        title="Embedded Content from Example.com"
        >
        Your browser doesn't support iframes.
        </iframe> */}
					</Card>
					
					</Box>

          <Divider sx={{ mt: 2, mx: 0 }} />

					<Box > 
						<Card elevation={0} sx={{minHeight:"40vh" }}>
							<CardContent>
								<Box >
									<Box display={"flex"} justifyContent={"space-between"} alignContent={"center"}>
							<Typography  sx={{ textAlign: 'center', mt:1 }} fontFamily="Gilroy-Bold" fontSize="18px" gutterBottom>Updates</Typography>
							<TextField
								id="time-filter"
								select
								
								defaultValue={"24hrs"}
								onChange={(e) => {
									setTimeFilter(e.target.value)
								}}
							sx={{fontFamily:"Gilroy-Medium", fontSize:"14px", '& .MuiInputLabel-root': { paddingLeft: 0, fontSize:'14px' },
							'& .MuiOutlinedInput-input': { padding: '11px 14px', fontSize:'14px' },marginRight:0, marginBottom:1}}
							
							>
								<MenuItem sx={{fontFamily:"Gilroy-Medium"}} value={"1hr"} >Last Hour</MenuItem>
								<MenuItem sx={{fontFamily:"Gilroy-Medium"}} value={"24hrs"} >Recent</MenuItem>
								<MenuItem sx={{fontFamily:"Gilroy-Medium"}} value={"All"} >All Updates</MenuItem>
							</TextField>
									</Box>
					{filteredUpdates[timeFilter as times].length ? filteredUpdates[timeFilter as times].map((update :any, index :any) => (
					<Box key={index} marginBottom={2} sx={{backgroundColor: statusStyles.Pending.status.includes(update.currentStatus) ? statusStyles.Pending.backgroundImage :  statusStyles.Success.status.includes(update.currentStatus) ? statusStyles.Success.backgroundImage :  statusStyles.Error.status.includes(update.currentStatus) ? statusStyles.Error.backgroundImage : statusStyles.Pending.backgroundImage}}>
					  
					  <ListItem>
						  <Typography fontFamily="Gilroy-Light" fontSize="10px" sx={{padding: 1, background: "#ffffff"}}>
							{update.resourceType.toUpperCase()}</Typography>
					  </ListItem>
					  <ListItem>
					
						<Typography fontFamily="Gilroy-Medium" fontSize="14px" >{`Current ${update.resourceType}: ${update.resourceName?.toUpperCase()} at ${update?.resourceEnvironment|| 'dev'} has status: ${update?.currentStatus }`}</Typography>
						{/* {update.currentStatus == 'rejected' ? <Typography fontFamily="Gilroy-Medium" fontSize="14px">`Reason for rejection` </Typography> : null} */}
					  </ListItem>
					  <ListItem sx={{color:"rgba(102, 102, 102, 1)", display: "flex",alignItems: "center", }}>
					  	<RiCalendarView/>
						  {/* <Typography marginLeft={1}>{(new Date(update.updatedAt*1000)).toLocaleDateString("en-IN")}</Typography> */}
						  <Typography fontFamily="Gilroy-Medium" fontSize="10px" marginLeft={1}>{convertUnixTimeToDate(update.updatedAt)}</Typography>
						  <Box display="flex" alignItems="center" justifyContent="flex-start" marginLeft={2}>
									<Avatar
										sx={{ height: "16px", width: "16px", marginRight: 0.5 }}
										src={update.resourceOwner?.googleProfilePicture}
									/>
									<Typography fontFamily="Gilroy-Medium" fontSize="10px">
										{update.resourceOwner?.name}
									</Typography>
								</Box>
								
					  </ListItem>
					  {/* {index < updates.length - 1 && <Divider />} */}
					{/* <Typography>{typeof(update.updatedAt)}</Typography> */}
					{/* <Typography>{timeDifference(Date.now(),update.updatedAt)}</Typography> */}
					</Box>
				  )):<Box><Box
													sx={{
														position: "relative",
														top: "50%",
														left: "50%",
														transform: "translate(-50%, -1%)",
														width: "30vw",
													}}
													display="flex"
													flexDirection="column"
													flex={1}
													alignItems="center"
													justifyContent="center"
												>
													<img src="/assets/inbox-icon.svg" alt="empty" />
													<Typography
														gutterBottom
														fontFamily="Gilroy-Bold"
														fontSize="16px"
														px={2}
														textAlign="center"
													>
														You are all caught up!
													</Typography>
													
												</Box></Box>}
				  </Box>
				  </CardContent>
				  </Card>
					</Box>
				
				
        </RightBox>
		

			</Box>



			</Box>
		</Box>
	);
};

export default DashBoardPage;












// import React from "react";
// import MainDrawer, { openDrawerWidth, collapsedDrawerWidth } from "./MainDrawer";
// import { useState } from "react";
// import queryGraphql from "../helpers/ApiInterface";
// import { useAuth } from "../helpers/AuthProvider";
// import { useNavigate, Link as RouterLink } from "react-router-dom";
// import {  ArrowForwardIosOutlined } from "@mui/icons-material";
// import {  useTheme } from '@mui/material/styles';
// import { Link } from 'react-router-dom'; 
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import {
// 	AppBar,
// 	Toolbar,
// 	Typography,
// 	Box,
// 	Grid,
// 	Card,
// 	CardContent,
// 	CardMedia,
// 	List,
// 	ListItem,
// 	ListItemText,
// 	Divider,
// 	Button,
// 	Accordion,
// 	AccordionDetails,
// 	AccordionSummary,
// 	Avatar,
// 	IconButton,
// 	Autocomplete,
// 	TextField,
// 	Tooltip,
// 	Menu,
// 	MenuItem,
//   styled
//   } from '@mui/material';
// import { RollerShades , ExpandMore, BorderAll} from "@mui/icons-material";
// import { RiCalendarView } from "react-icons/ri";
// import { RiArchiveDrawerLine,RiArchiveStackLine,RiBubbleChartLine, RiGroupLine } from "react-icons/ri";
// import MiniBot from "./MiniBot";

// let navPaneList: any = [

//   {
//     id: "clusters",
//     text: "Clusters",
//     nav: "/clusters",
//     icon: <RiArchiveDrawerLine />,
//     visibility: ["cluster_owner", "viewer"],
//   },
//   {
//     id: "applications",
//     text: "Applications",
//     nav: "/applications",
//     icon: <RiArchiveStackLine />,
//     visibility: [
//       "application_owner",
//       "developer",
// 	  "viewer"
//     ],
//   },
//   {
//     id: "services",
//     text: "Services",
//     nav: "/services",
//     icon: <RiBubbleChartLine />,
//     visibility: [  "developer", "viewer"],
//   },
//     {
//       id: "user-management",
//       text: "User",
//       icon: <RiGroupLine />,
//       nav: "/user-management",
//       visibility: ["idp_admin", "viewer"],
//     },
// 	{
// 			id: "requests-cluster",
// 			text: "Request/Clusters",
// 			icon: <RiArchiveDrawerLine />,
// 			nav: "/requests/clusters",
// 			visibility: ["infrastructure_admin", "viewer"],
// 		  },
// 		  {
// 			id: "requests-application",
// 			text: "Requests/Applications",
// 			icon: <RiArchiveStackLine />,
// 			nav: "/requests/applications",
// 			visibility: ["infrastructure_admin", "viewer"],
// 		  },
// 		  {
// 			id: "requests-service",
// 			text: "Requests/Services",
// 			icon: <RiBubbleChartLine />,
// 			nav: "/requests/services",
// 			visibility: ["application_owner", "viewer"],
// 		  },
 
// ];


// const LeftBox = styled(Box)(({ theme }) => ({
//   flex: '70%', // Takes 70% of the parent's width
//   backgroundColor: '#f0f0f0',
//   // padding: theme.spacing(2),
//   border: '1px solid #ccc',
//   maxHeight:'90vh',
//   overflowY: "auto",
//   minWidth:'0',
//   display:"flex",
//   flexDirection:'column'
// }));

// const RightBox = styled(Box)(({ theme }) => ({
//   flex: '30%', // Takes 30% of the parent's width
//   backgroundColor: '#FFFFFF', 
//   padding: theme.spacing(2), 
//   border: '1px solid #ccc', 
//   maxHeight:'86vh',overflowY: "auto",
//   minWidth:'30vw',
//   display:"flex",
//   flexDirection:'column'
// }));

//   const knowledgeBankData = [
// 	{ title: "Next has something for everyone.", author: 'Google', date: '01/02/2025',  content: "Get a front-row seat for Google’s latest and greatest AI innovations and product launches, and learn new ways to drive growth and efficiency.", image: "/assets/kb_1.webp" , url: "https://cloud.withgoogle.com/next/25"},
// 	{ title: 'See you there!!', author: 'Searce', date: '01/01/2024',  content: "Assess your organization's current AI maturity level, gain valuable insights, and qualify for a complimentary session with Searce experts.", image:"/assets/kb_2.svg", url: "https://www.searce.com/googleNext2024" },
	
//   ];

//   type RoleKey = "idp_admin" | "infrastructure_admin" | "cluster_owner" | "application_owner" | "developer" | "viewer";
//   type Questions = "general" | "cluster" | "application" | "service" ;
//   type times = "1hr" | "24hrs" |"All";
//   const timeList = ["1hr","24hrs","All"];
  


//   const questions = {
// 	general : [
// 	{
// 			question: "What is the significance of Intellicore?",
// 			answer: "Intellicore provides a self-service environment for you to easily create and manage your cloud infrastructure. You can build Kubernetes clusters, deploy applications, and configure various services, all through a user-friendly interface."
// 	},
// 	{
// 		question: "Who can use Intellicore?",
// 		answer: "Intellicore is designed for developers, DevOps engineers, and IT professionals who need to deploy and manage applications in a cloud environment. Access is granted based on roles and permissions defined by your organization's administrator."
// 	},
// 	{
// 		question: "What are the different roles on Intellicore?",
// 		answer: "Different roles provide different levels of authorized access within Intellicore. Different roles are- IDP Admin, Infrastructure Admin, Platform Owner, Application Owner and Developer."
// 	},
// 	{
// 		question: "Who is an IDP Admin",
// 		answer: "An IDP admin plays a crucial role in authorizing the roles to other users on Intellicore as well as he/she observes all the activities on Intellicore. "
// 	},
// 	{
// 		question: "What are the key responsibilities and capabilities of Infrastructure admins and Cluster Owners?",
// 		answer: "Infrastructure Admin's sole role is to approve or reject the creation of clusters and applications on Intellicore. While Cluster Owner can apply for the Cluster creation.  "
// 	},
// 	,
// 	{
// 		question: "What level of access and control do Application Owner and Developers have within the Intellicore?",
// 		answer: "Application Owners have the access to approve the services requested by the developers. As well as they can apply for application creation on Intellicore. While developers can only apply for the services. "
// 	}

// 	],
// 	cluster : [
// 	{
// 			question: "What types of clusters can I create?",
// 			answer: "For now we can only create autopilot clusters under stable release channel."
// 	},
// 	{
// 			question: "How long does it take to create the cluster?",
// 			answer: "It totally depends on the approver, once the approver accepts the requests and also approves the MR at the backend, cluster gets created in 20 mins."

// 	},
// 	{
// 		question: "How do I access my cluster?",
// 		answer: "Once the cluster is created necessary urls are provided on Intellicore."

// }
	

// 	],

// 	application : [
// 		{
// 				question: "What is an application ?",
// 				answer: "Application where you can deploy multiple services. It creates the necessary gitlab resources and make the basic deployments into the cluster."
// 		},
// 		{
// 				question: "How do I monitor my application?",
// 				answer: "You can monitor the application with the help of updates at the bottom of each application description page."
	
// 		}
	
// 		],

// 	service : [
// 		{
// 				question: "What is a service?",
// 				answer: "A service can be a simple microservice for an application, a user can commit the changes and it gets deployed and can be shared with others."
// 		},
// 		{
// 				question: "What all services are available?",
// 				answer: "Currently only nodejs service is available."
	
// 		}
	
// 		],
	

		
//   }
//   const PREDEFINED_ORDER = [
//     "idp_admin",
//     "infrastructure_admin",
//     "cluster_owner",
//     "application_owner",
//     "developer", "viewer"
//   ];
//   // --- Interface Definitions for Policy Overview ---
// interface PolicyResourceStatus {
//     id: string; // Unique ID for React key prop
//     name: string;
//     hasFailures?: boolean;
// }
// interface PolicySummary {
//     total: number;
//     violating?: number;
//     resources: PolicyResourceStatus[];
// }
// // --- End Interface Definitions ---

// // Simple styled component for the indicator squares
// const PolicyIndicatorSquare = styled(Box)(({ theme }) => ({
//     width: '12px',
//     height: '12px',
//     borderRadius: '2px',
//     margin: '2px', // Small gap between squares
// }));

// const DashBoardPage: React.FC = () => {

// 	const { user } = useAuth();
// 	const isViewer = user?.roles?.some(
// 			(role: string) => role === "viewer" 
// 		) || false;
// 	// const role = user.roles[0] as RoleKey; 
	
// 	const [clusters, setClusters] = useState<any>([]);
// 	const [applications, setApplications] = useState<any>([]);
// 	const [services, setServices] = useState<any>([]);
// 	const [bigQueryClusterCost, setBigQueryClusterCost] = useState<any>([]);
// 	const [bigQueryApplicationCost, setBigQueryApplicationCost] = useState<any>([]);
// 	const [bigQueryServiceCost, setBigQueryServiceCost] = useState<any>([]);
// 	const [bigQueryClusterCostRecent, setBigQueryClusterCostRecent] = useState<any>();
// 	const [bigQueryApplicationCostRecent, setBigQueryApplicationCostRecent] = useState<any>();
// 	const [bigQueryServiceCostRecent, setBigQueryServiceCostRecent] = useState<any>();
// 	const [integrations, setIntegrations] = useState<any>({});
// 	const [questionsType, setQuestionsType] = useState<string>('general');
// 	const qt = questionsType as Questions;
// 	const [updates, setUpdates] =  useState<any>([]);
// 	const [timeFilter,setTimeFilter] = useState<any>("24hrs");
// 	const navigate = useNavigate();
// 	    // State for Raw Checkov Results (kept in case needed elsewhere)
//     const [checkovResults, setCheckovResults] = useState<any[]>([]);
// 	const [kyvernoResults, setKyvernoResults] = useState<any[]>([]);
//     // ADDED STATE FOR PROCESSED POLICY OVERVIEW DATA
//     const [clusterPolicySummary, setClusterPolicySummary] = useState<PolicySummary>({ total: 0, violating: 0, resources: [] });
//     const [applicationPolicySummary, setApplicationPolicySummary] = useState<PolicySummary>({ total: 0, violating: 0, resources: [] });
//     const [servicePolicySummary, setServicePolicySummary] = useState<PolicySummary>({ total: 0, violating: 0, resources: [] });
// 	const [kyvernoClusterPolicySummary, setKyvernoClusterPolicySummary] = useState<PolicySummary>({ total: 0, resources: [] }); // <-- ADDED for Kyverno Summary (no violating needed)
//     // --- End State Variables ---
//   const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);

//   const rolesSet = new Set(user.roles);
// 	const roles = PREDEFINED_ORDER.filter(role => rolesSet.has(role)) ;
// 	const role = roles[0] as RoleKey;
	
//   const handleClick = (event:any) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };
  
//    React.useEffect(() => {
// 	        const fetchAndProcessCheckovData = async () => {
// 	            if (integrations?.checkov?.enabled === true) {
// 	                console.log("Checkov enabled, fetching results...");
// 	                try {
// 	                    const data = await queryGraphql(`
// 	                        query GetCheckovResults {
// 	                            getCheckovResults {
// 	                                id resourceId resourceType summary { passed failed }
// 	                                application { applicationName environment} service { serviceName } cluster { clusterName environment }
// 	                            }
// 	                        }
// 	                    `, {}); // Query structure assumed based on previous code
	
// 	                    const results = data?.getCheckovResults || [];
// 	                    setCheckovResults(results);
// 	                    console.log("Checkov raw results fetched:", results);
	
// 	                    // Process Data for Policy Overview
// 	                    const clusters: PolicyResourceStatus[] = [];
// 	                    const applications: PolicyResourceStatus[] = [];
// 	                    const services: PolicyResourceStatus[] = [];
	
// 	                    results.forEach((result: any) => {
// 	                        const hasFailures = result.summary.failed > 0;
// 	                        const id = result.id || result.resourceId || `fallback-${Math.random()}`; // Ensure unique key
// 	                        let name = 'Unknown Resource'; // Default name
	
// 	                        if (result.resourceType === 'cluster' && result.cluster) {
// 	                            name = result.cluster.clusterName + '-' + result.cluster.environment || `Cluster ${result.resourceId || result.id}`;
// 	                            clusters.push({ id, name, hasFailures });
// 	                        } else if (result.resourceType === 'application' && result.application) {
// 	                            name = result.application.applicationName + '-' + result.application.environment || `App ${result.resourceId || result.id}`;
// 	                            applications.push({ id, name, hasFailures });
// 	                        } else if (result.resourceType === 'service' && result.service) {
// 	                            name = result.service.serviceName + '-' + 'dev'|| `Service ${result.resourceId || result.id}`;
// 	                            services.push({ id, name, hasFailures });
// 	                        }
// 	                    });
	
// 	                    // Update state with processed summaries
// 	                    setClusterPolicySummary({ total: clusters.length, violating: clusters.filter(c => c.hasFailures).length, resources: clusters });
// 	                    setApplicationPolicySummary({ total: applications.length, violating: applications.filter(a => a.hasFailures).length, resources: applications });
// 	                    setServicePolicySummary({ total: services.length, violating: services.filter(s => s.hasFailures).length, resources: services });
// 	                    console.log("Policy Overview Data Processed");
	
// 	                } catch (e) {
// 	                    console.error("Error fetching/processing Checkov results:", e);
// 	                    setCheckovResults([]);
// 	                    setClusterPolicySummary({ total: 0, violating: 0, resources: [] });
// 	                    setApplicationPolicySummary({ total: 0, violating: 0, resources: [] });
// 	                    setServicePolicySummary({ total: 0, violating: 0, resources: [] });
// 	                }
// 	            } else {
// 	                 setCheckovResults([]);
// 	                 setClusterPolicySummary({ total: 0, violating: 0, resources: [] });
// 	                 setApplicationPolicySummary({ total: 0, violating: 0, resources: [] });
// 	                 setServicePolicySummary({ total: 0, violating: 0, resources: [] });
// 	                 if(integrations && typeof integrations.checkov !== 'undefined') {
// 	                    console.log("Checkov is not enabled, skipping policy overview update.");
// 	                 }
// 	            }
// 	        };
// 			const fetchAndProcessKyvernoData = async () => {
// 				if (integrations?.kyverno?.enabled === true) {
// 				  console.log("Kyverno enabled, fetching results...");
// 				  try {
// 					const data = await queryGraphql(`
// 						query GetKyvernoResults {
// 							getKyvernoResults {
// 								id
// 								resourceId
// 								resourceType
// 								cluster {
// 									clusterName
// 									environment
// 								}
// 							}
// 						}
// 					`, {});
		  
// 					const results = data?.getKyvernoResults || [];
// 					setKyvernoResults(results);
// 					console.log("Kyverno raw results fetched:", results);
		  
// 					// Process Data for Policy Overview
// 					const clusters: PolicyResourceStatus[] = [];
		  
// 					results.forEach((result: any) => {
// 					  if (result.resourceType === 'cluster' && result.cluster) {
// 						// Use a more specific fallback prefix
// 						const id = result.id || result.resourceId || `kyverno-fallback-${Math.random()}`;
// 						const name = `${result.cluster.clusterName}-${result.cluster.environment}` || `Cluster ${result.resourceId || result.id}`;
// 						clusters.push({ id, name }); // Note: No 'hasFailures'
// 					  }
// 					});
		  
// 					setKyvernoClusterPolicySummary({ total: clusters.length, resources: clusters });
// 					console.log("Kyverno Policy Overview Data Processed");
		  
// 				  } catch (e) {
// 					console.error("Error fetching/processing Kyverno results:", e);
// 					setKyvernoResults([]);
// 					setKyvernoClusterPolicySummary({ total: 0, resources: [] });
// 				  }
// 				} else {
// 				  setKyvernoResults([]);
// 				  setKyvernoClusterPolicySummary({ total: 0, resources: [] });
// 				  if (integrations && typeof integrations.kyverno !== 'undefined') {
// 					console.log("Kyverno is not enabled, skipping policy overview update.");
// 				  }
// 				}
// 			  };
// 	        if (integrations && typeof integrations.checkov !== 'undefined') {
// 	           fetchAndProcessCheckovData();
// 			   fetchAndProcessKyvernoData();
// 	        }
// 			else {
// 				// Optional: Reset states if integrations are cleared or not loaded yet
// 				setClusterPolicySummary({ total: 0, violating: 0, resources: [] });
// 				setApplicationPolicySummary({ total: 0, violating: 0, resources: [] });
// 				setServicePolicySummary({ total: 0, violating: 0, resources: [] });
// 				setKyvernoClusterPolicySummary({ total: 0, resources: [] });
// 			  }
// 	    }, [integrations]);

//   React.useEffect(() =>{
//     const fetchData = async () => {
//       try {
//         const data = await queryGraphql(`
//            query CostAgent {
//               getIntegrations {
//                 costAgent {
//                   datasetId
//                   enabled
//                   projectId
//                   serviceAccountName
//                   tableId
//                   updatedAt
//                 }
//                 checkov {
//                   enabled
//                 }
//                 kyverno {
//                   enabled
//                 }
//                 prometheus {
//                   enabled
//                 }
//               }
//             }
//           `, 
//             {}
//             );
//         if(data?.getIntegrations){
//          await setIntegrations(data?.getIntegrations);
//           console.log(integrations);
//         }
//         }
//         catch(e){
//       console.log(e);
//         }
//   }
//   fetchData();
//   },[]);

//   React.useEffect(() =>{
// 	const fetchData = async () => {
// 		try {
// 			const data = await queryGraphql(`
// 					query Query($type: String!) {
// 						bigQueryData(type: $type)
// 						}
// 				`, 
// 					{type: "cluster"}
// 				  );
// 			if(data.bigQueryData){
// 				setBigQueryClusterCost(data?.bigQueryData?.rows[0]?.total_cost_for_label);
// 			}
// 			}
// 			catch(e){
// 		console.log(e);
// 			}
// }
// fetchData();
// },[]);

// React.useEffect(() =>{
// 	const fetchData = async () => {
// 		try {
// 			const data = await queryGraphql(`
// 					query Query($type: String!) {
// 						bigQueryData(type: $type)
// 						}
// 				`, 
// 					{type: "cluster_recent"}
// 				  );
// 			if(data.bigQueryData){
// 				setBigQueryClusterCostRecent(data?.bigQueryData?.rows[0]?.costDifference);
// 			}
// 			}
// 			catch(e){
// 		console.log(e);
// 			}
// }
// fetchData();
// },[]);

// React.useEffect(() =>{
// 	const fetchData = async () => {
// 		try {
// 			const data = await queryGraphql(`
// 					query Query($type: String!) {
// 						bigQueryData(type: $type)
// 						}
// 				`, 
// 					{type: "application"}
// 				  );
// 			if(data.bigQueryData){
// 				setBigQueryApplicationCost(data?.bigQueryData?.rows[0]?.total_cost_for_label);
// 			}
// 			}
// 			catch(e){
// 		console.log(e);
// 			}
// }
// fetchData();
// },[]);

// React.useEffect(() =>{
// 	const fetchData = async () => {
// 		try {
// 			const data = await queryGraphql(`
// 					query Query($type: String!) {
// 						bigQueryData(type: $type)
// 						}
// 				`, 
// 					{type: "application_recent"}
// 				  );
// 			if(data.bigQueryData){
// 				setBigQueryApplicationCostRecent(data?.bigQueryData?.rows[0]?.costDifference);
// 			}
// 			}
// 			catch(e){
// 		console.log(e);
// 			}
// }
// fetchData();
// },[]);

// React.useEffect(() =>{
// 	const fetchData = async () => {
// 		try {
// 			const data = await queryGraphql(`
// 					query Query($type: String!) {
// 						bigQueryData(type: $type)
// 						}
// 				`, 
// 					{type: "service"}
// 				  );
// 			if(data.bigQueryData){
// 				setBigQueryServiceCost(data?.bigQueryData?.rows[0]?.total_cost_for_label);
// 			}
// 			}
// 			catch(e){
// 		console.log(e);
// 			}
// }
// fetchData();
// },[]);

// React.useEffect(() =>{
// 	const fetchData = async () => {
// 		try {
// 			const data = await queryGraphql(`
// 					query Query($type: String!) {
// 						bigQueryData(type: $type)
// 						}
// 				`, 
// 					{type: "service_recent"}
// 				  );
// 			if(data.bigQueryData){
// 				setBigQueryServiceCostRecent(data?.bigQueryData?.rows[0]?.costDifference);
// 			}
// 			}
// 			catch(e){
// 		console.log(e);
// 			}
// }
// fetchData();
// },[]);

//   let list = navPaneList.filter((e:any) => e.visibility.includes(role)).map((e: any) => e.text);
// //   console.log("lstttt",list);
//   // console.log(user.roles[0]);
// 	React.useEffect(() =>{
// 		const fetchData = async () => {
// 			try {
// 				const data = await queryGraphql(`
//                         query Query {
// 						resourceStatuses {
// 							id
// 							resourceId
// 							resourceName
// 							currentStatus
// 							resourceType
// 							resourceEnvironment
// 							resourceOwner {
// 							id
// 							name
// 							googleProfilePicture
// 							}
// 							projectUrl
// 							gcpClusterUrl
// 							argoCdStaticUrl
// 							subGroupProjectAppUrl
// 							subGroupProjectInfraUrl
// 							createdAt
// 							updatedAt
// 						}
// 						}
// 					`);
// 				if(data.resourceStatuses){
// 					setUpdates(data.resourceStatuses);
// 					setUpdates((prevData:any) => [...prevData].reverse())
// 				}
// 				}
// 				catch(e){
// 			console.log(e);
// 				}
// 	}
// 	fetchData();
// 	},[]);

//  	React.useEffect(() =>{
// 		const fetchData = async () => {
// 			try {
// 				const data = await queryGraphql(`
//                         query{
// 						services{
// 						id,
// 						serviceName,
// 						framework,
// 						gcpServiceViewers,
// 						serviceOwner{
// 						id,
// 						name,email,
// 						googleProfilePicture
// 						},
// 						application{
// 						id,
// 						applicationName,
// 						cluster{
// 						id,
// 						clusterName,
// 				}
// 						},
// 						createdAt,
// 						status
// 						}
// 				}
// 					`)
// 				if(data.services){
// 					setServices(data.services);
					
// 				}
// 				}
// 					catch(e){
// 			console.log(e);
// 		}
// 	}
// 	fetchData();
// 	},[]);

// 	React.useEffect(() =>{
// 		const fetchData = async () => {
// 			try {
// 				const data = await queryGraphql(`
//                         query{
//                         applications {
// 						id,
//                         applicationName,
// 						environment,
// 						status,
// 						createdAt,
// 						gcpApplicationViewers,
// 						applicationOwner{
// 						id,
// 						},
// 						cluster{
// 						id,
// 						clusterName,
// 						},
//                         applicationOwner{
// 						id,
// 						email,
// 						name,
// 						googleProfilePicture
// 						},
// 						services{
// 						id,
// 						serviceName,
// 						}
//                         }
//                         }
// 					`)
// 				if(data.applications){
// 					setApplications(data.applications);
// 				}
// 				}
// 					catch(e){
// 			console.log(e);
// 		}
// 	}
// 	fetchData();
// 	},[]);

// 	React.useEffect(() => {
// 		(async () => {
// 			try {
// 				const data = await queryGraphql(
// 					`
//                        query{
//                         clusters {
// 						id,
//                         clusterName,
//                         environment,
// 						status,
// 						gcpClusterViewers,
// 						clusterOwner {
// 							id
// 							},
// 						clusterApprover {
// 							id
// 							},
// 						applications {
// 							id
// 							applicationName
// 							status
// 							environment,
// 							applicationOwner {
// 								id
// 								},
// 							services {
// 									serviceName
// 									id
// 									status
// 								}
// 							}
//                         }
//                         }
// 					`
// 				);
// 				// console.log(data.clusters);
// 				if (data.clusters) {
// 					setClusters(data.clusters);
					
// 			}
			

// 			// console.log("Value",clusters.reduce((accumulator : any, cluster : any) => {
          
//             //     if (cluster.clusterApprover?.id === user.id) {
//             //         return accumulator + cluster.applications.length; 
//             //     }
//             //     return accumulator; 
//             // }, 0))


// 			// console.log(clusters.reduce((accumulator : any, cluster : any) => {
          
//             //     if (cluster.clusterApprover?.id === user.id) {
                   
//             //         const clusterServices = cluster.applications.map((application: any) =>
//             //             application.services
//             //         ).map((service: any) => service); 

//             //         return accumulator + clusterServices.length;
//             //     }
//             //     return accumulator; 
//             // }, 0))

			
// 			// const uniqueClusterIds = Array.from(
// 			// 	new Set(
// 			// 	  applications.filter((application :any) => application.applicationOwner.id === user.id) 
// 			// 		.map((application: any) => application.clusterId)
// 			// 	)
// 			//   );
// 			//   console.log("e",services);

// 			// console.log("Data",Array.from(new Set (services.filter((service : any) => service.serviceOwner.id == user.id).map((service : any) => service.application.cluster.id))));


// 		} catch (error) {
// 				console.log(error);
// 			}
// 		})();
// 	}, []);
// 	const PolicyIndicatorSquare = styled(Box)(({ theme }) => ({
// 		width: '14px',
// 		height: '14px',
// 		borderRadius: '3px', // Slightly rounded square
// 		margin: '2px',
// 		display: 'inline-block',
// 		transition: theme.transitions.create(['transform', 'box-shadow'], { // Use theme transitions
// 			duration: theme.transitions.duration.shorter,
// 		}),
// 		cursor: 'pointer',
// 		flexShrink: 0,
// 		// Hover effects moved to sx prop where used for dynamic behavior
// 	}));
	
// 	const theme = useTheme(); // Get theme for transitions

//     // Color constants based on image/common practice
// 	const passColor = '#12B76A'; // Green
//     const failColor = '#F04438'; // Red
//     const violatingTextColor = '#D32F2F'; // Darker Red for text
//     const iconColor = '#555'; // Slightly darker grey for icons
// 	const kyvernoColor = '#2196F3'; // <-- ADDED Blue for Kyverno
//     // Gradient matching "top to bottom" purple from image
//     // Adjust colors and percentages as needed for exact match
//     //const headerGradient = 'linear-gradient(to bottom, rgba(220, 206, 240, 0.7) 0%, rgba(237, 231, 246, 0.3) 60%, transparent 100%)';
// 	const checkovHeaderGradient = 'linear-gradient(to bottom, rgba(220, 206, 240, 0.7) 0%, rgba(237, 231, 246, 0.3) 60%, transparent 100%)';
// 	//const kyvernoHeaderGradient = 'linear-gradient(to bottom, rgba(255, 237, 224, 0.5) 0%, rgba(255, 245, 238, 0.1) 60%, transparent 100%)';
// 	// Slightly darker orange gradient
//     const kyvernoHeaderGradient = 'linear-gradient(to bottom, rgba(255, 237, 224, 0.7) 0%, rgba(255, 245, 238, 0.3) 60%, transparent 100%)';
// 	const showPolicyOverview = integrations?.checkov?.enabled || integrations?.kyverno?.enabled; // <-- ADDED conditional flag
//     // const headerGradient = 'linear-gradient(90deg, rgba(227, 219, 247, 0.65) 0%, rgba(237, 231, 246, 0.2) 75%, transparent 100%)'; // Alternative from snippet

//     // Fallback data to prevent errors if summaries are initially null/undefined
//     const safeClusterSummary = clusterPolicySummary || { total: 0, violating: 0, resources: [] };
//     const safeAppSummary = applicationPolicySummary || { total: 0, violating: 0, resources: [] };
//     const safeServiceSummary = servicePolicySummary || { total: 0, violating: 0, resources: [] };
// 	const safeKyvernoClusterSummary = kyvernoClusterPolicySummary || { total: 0, resources: [] }; // <-- ADDED Kyverno Safe Summary
// 	const rolesData= {
// 		idp_admin:{
// 			clustersList : clusters.filter((cluster : any) => cluster.status == 'active').length, // He should be able to see all the active clusters 
// 			applicationsList: clusters?.filter((cluster : any) => cluster?.status == 'active').flatMap((cluster: any) => cluster?.applications?.filter((application: any) => application.status == 'active')).length, // He should be able to see all the active application 
// 			servicesList: clusters.filter((cluster : any) => cluster.status == 'active').flatMap((cluster : any) => cluster.applications?.filter((application: any) => application.status == 'active').flatMap((application : any )=> application.services?.filter((service: any) => service.status == 'active'))).length // He should be able to see all the active services

// 		},
// 		infrastructure_admin:{
// 			clustersList : clusters.filter((cluster : any) => cluster.status == 'active').length, 
// 			applicationsList : clusters?.filter((cluster : any) => cluster?.status == 'active').flatMap((cluster?: any) => cluster?.applications?.filter((application: any) => application.status == 'active')).length, 
// 			// applicationsList : clusters.reduce((accumulator : any, cluster : any) => {
          
//             //     if (cluster.clusterApprover?.id === user.id ) {
//             //         return accumulator + cluster.applications.length; 
//             //     }
//             //     return accumulator; 
//             // }, 0),

// 			servicesList : clusters.filter((cluster : any) => cluster.status == 'active').flatMap((cluster : any) => cluster?.applications?.filter((application: any) => application.status == 'active').flatMap((application : any )=> application.services?.filter((service: any) => service.status == 'active'))).length, 
// 			// servicesList : clusters.reduce((accumulator : any, cluster : any) => { // He should be able to see all the applications for clusters he is the owner 
          
//             //     if (cluster.clusterApprover?.id === user.id) {
//             //         return accumulator + cluster.applications.reduce((acc : any, application: any) =>{
// 			// 			return acc + application.services.length;
// 			// 		},0); 
//             //     }
//             //     return accumulator; 
//             // }, 0),
			
// 		},
// 		cluster_owner:{
// 			clustersList : clusters.filter((cluster : any) => cluster.status == 'active').filter((cluster : any) => cluster.clusterOwner.id == user.id  ).length, // He should be able to see only cluster where he is the owner
// 			applicationsList : clusters?.filter((cluster : any) => cluster?.status == 'active').reduce((accumulator : any, cluster : any) => { // He should be able to see all the applications for clusters he is the owner 
          
//                 if (cluster?.clusterOwner?.id === user.id ) {
//                     return accumulator + cluster?.applications?.filter((application : any)=> application.status == 'active')?.length; 
//                 }
//                 return accumulator; 
//             }, 0),
			
// 			servicesList : clusters.filter((cluster : any) => cluster.status == 'active').reduce((accumulator : any, cluster : any) => { // He should be able to see all the services for clusters he is the owner 
          
//                 if (cluster.clusterOwner?.id === user.id ) {
//                     return accumulator + cluster?.applications?.filter((application : any)=> application.status == 'active').reduce((acc : any, application: any) =>{
// 						return acc + application?.services?.filter(((service : any)=> service.status == 'active')).length;
// 					},0); 
//                 }
//                 return accumulator; 
//             }, 0),
			
// 		},
// 		application_owner:{
// 			clustersList : Array.from(new Set(applications?.filter((application? :any) => application?.status == 'active').filter((application? : any) => application?.applicationOwner?.id == user.id ).map((application? : any) => application?.id))).length,
// 			applicationsList : applications.filter((application :any) => application.status == 'active').filter((application:any) => application.applicationOwner.id == user.id ).length,
// 			// servicesList : (applications.filter((application :any) => application.status == 'active').filter((application:any) => application.applicationOwner.id == user.id ).map((application : any) => application.services ? application.services: null )).length,
// 			servicesList: applications.filter((application: any) => application.status == 'active').filter((application: any) => application.applicationOwner.id == user.id).map((application: any) => application.services ? application.services : null).filter((services: any) => services !== null && services.length > 0).map((services: any) => services.filter((service: any) => service.status === 'active')).reduce((totalService:any, services:any) => totalService + services.length, 0)
// 			// Make changes for the active services only
// 		},
// 		developer:{
// 			clustersList : Array.from(new Set (services.filter((service : any) => service.status == 'active')?.filter((service : any) => service.serviceOwner.id == user.id )?.map((service : any) => service?.application?.cluster?.id)))?.length,
// 			applicationsList : Array.from(new Set (services.filter((service : any) => service.status == 'active')?.filter((service : any) => service.serviceOwner.id == user.id )?.map((service : any) => service?.application?.id)))?.length,
// 			servicesList : services?.filter((service : any) => service.status == 'active').filter((service : any) => service.serviceOwner.id == user.id )?.length,
// 		}, 
// 		viewer:{
// 			clustersList : clusters.filter((cluster : any) => cluster.status == 'active').length, // He should be able to see all the active clusters 
// 			applicationsList: clusters.filter((cluster : any) => cluster.status == 'active').flatMap((cluster: any) => cluster.applications?.filter((application: any) => application.status == 'active')).length, // He should be able to see all the active application 
// 			servicesList: clusters.filter((cluster : any) => cluster.status == 'active').flatMap((cluster : any) => cluster.applications?.filter((application: any) => application.status == 'active').flatMap((application : any )=> application.services?.filter((service: any) => service.status == 'active'))).length // He should be able to see all the active services

// 		},

		
// 	}

// 	// const filteredUpdates = {
// 	// "All": {idp_admin: updates,
// 	// 	infrastructure_admin: updates,
// 	// 	cluster_owner: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "cluster" ),
// 	// 	application_owner: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "application" ),
// 	// 	developer: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "service" )
// 	// },
// 	// "24hrs": {idp_admin: updates.filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 24),
// 	// 	infrastructure_admin: updates.filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 24),
// 	// 	cluster_owner: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "cluster" ).filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 24),
// 	// 	application_owner: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "application" ).filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 24),
// 	// 	developer: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "service" ).filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 24)
// 	// },
// 	// "1hr": {idp_admin: updates.filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 1),
// 	// 	infrastructure_admin: updates.filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 1),
// 	// 	cluster_owner: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "cluster" ).filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 1),
// 	// 	application_owner: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "application" ).filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 1),
// 	// 	developer: updates.filter((update:any) => update.resourceOwner.id == user.id && update.resourceType == "service" ).filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 1)
// 	// },	
// 	// }

// 	const filteredUpdates = {
// 		"All": updates,
// 		"24hrs": updates.filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 24),
// 		"1hr": updates.filter((update:any) => timeDifference(Date.now(),update.updatedAt) < 1)		
// 		}

// 	const statusStyles = {
// 		Loading: {
// 			backgroundImage: 'rgba(253, 176, 34, 1)'
			
// 		  },
// 		Success: {
// 			backgroundImage: 'rgba(18, 183, 106, 0.06)',
// 			status: ['active','Initiated','Fact File Created','Plan Successful','Cluster Creation Initiated', 'Service Creation Initiated','Cluster Created','Service Creation Completed', 'App Creation Initiated','App Creation Completed','Infra Audit Successful']
// 		  },
// 		Error: {
// 			backgroundImage: 'rgba(240, 68, 56, 0.06)',
// 			status: ['rejected','Plan Failed','Cluster Creation Failed','GitlabResources Creation Failed','App Creation Failed','Infra Audit Failed'],
// 		  },
// 		Pending: {
// 			backgroundImage: 'rgba(248, 248, 248, 1)',
// 			status: ['pending','MR Approval Pending'],
// 		  },
	  
// 	  }

// 	function convertUnixTimeToDate(unixTimestamp : any) {
// 		const timestamp = Number(unixTimestamp);
// 		const date = new Date(timestamp);
// 		const formattedDate = date.toLocaleString('en-GB', { 
// 		day: '2-digit',
// 		month: '2-digit',
// 		year: 'numeric'
// 		});

// 		return formattedDate;
// 	  }
// 	function convertUnixToISO(unixTimestamp : any) {
// 		const timestamp = Number(unixTimestamp);
// 		try {
// 		  const date = new Date(timestamp);
// 		  return date.toISOString();
// 		} catch (error) {
// 		  console.error("Invalid Unix timestamp:", error);
// 		  return "Invalid Date";
// 		}
// 	  }
// 	//   This function helps us to get the difference between two unix timestamps in hours
// 	function timeDifference(timeA:any, timeB: any){
// 		let timeStampA = new Date(convertUnixToISO(timeA));
// 		let timeStampB = new Date(convertUnixToISO(timeB));

// 		const differenceMilliseconds = timeStampA.getTime() - timeStampB.getTime();
// 		const differenceMinutes = (differenceMilliseconds / (60*60*1000));
// 		return differenceMinutes;
// 	}
// 	const getInitialDrawerState = () => {
// 			if (typeof window !== 'undefined') {
// 				const storedState = localStorage.getItem('isFaradayDrawerOpen');
// 				return storedState !== null ? JSON.parse(storedState) : true;
// 			}
// 			return true;
// 		};
// 		const [isDrawerActuallyOpen, setIsDrawerActuallyOpen] = useState<boolean>(getInitialDrawerState);
	
// 		const handleDrawerStateChange = (isOpenFromDrawer: boolean) => {
// 			setIsDrawerActuallyOpen(isOpenFromDrawer);
// 		};
	 
// // console.log("updates",updates);
// 	  return (
// 		<Box sx={{ display: "flex" }}>
// 			{isDrawerActuallyOpen && (
//                 <MainDrawer
//                 // Assuming "integrations" is the correct index for Kyverno page
//                 // If Kyverno has its own top-level menu item, update this index.
//                 index={"overview"} // Or a more specific index like "integrations-kyverno" if applicable            
//                 onStateChange={handleDrawerStateChange}
//             />
//             )}
//             {!isDrawerActuallyOpen && (
//                 <MainDrawer
//                 // Assuming "integrations" is the correct index for Kyverno page
//                 // If Kyverno has its own top-level menu item, update this index.
//                 index={"overview"} // Or a more specific index like "integrations-kyverno" if applicable
//                 onStateChange={handleDrawerStateChange}
//             />
//             )}
// 			<MiniBot/>
// 			<Box sx={{
// 					flex: 1,
// 					bgcolor: "#fafafa",
// 					minHeight: window.innerHeight,
// 				}}>
// 			<Box bgcolor="#FFFFFF" pb={2} pt={2} mb={0}>

		
// 			            <Box
// 										sx={{
// 											display: "flex",
// 											justifyContent: "space-between",
// 											alignItems: "center",
// 											marginBottom: 0,
// 											mx: 4,
// 										}}
// 									>
// 										<Typography fontSize="22px" gutterBottom fontFamily="Gilroy-Bold">
// 											Overview
// 										</Typography>
                    
                   
// 								<Box sx={{display:'flex', justifyContent:'center'}}>
//                                   <Button
//                                           variant="contained"
//                                           color="primary"
//                                           sx={{
//                                             backgroundColor: "black",
//                                             color: "white",
//                                             padding: "8px 24px",
//                                             fontSize: "0.875rem",
//                                             textTransform: "none",
//                                             display: 'flex', // To align the arrow icon with the text
//                                             alignItems: 'center',
//                                           }}
//                                           id="go-to-button"
// 										  disabled={isViewer}
//                                           aria-controls={open ? 'go-to-menu' : undefined}
//                                           aria-haspopup="true"
//                                           aria-expanded={open ? 'true' : undefined}
//                                           onClick={handleClick}
//                                         >
//                                           <Typography fontSize="14px" fontFamily="Gilroy-Bold">
//                                             Add new
//                                           </Typography>
//                                           <ArrowForwardIosOutlined sx={{ml: 1, fontSize:"14px"}} />
//                                         </Button>
// 											<IconButton
//           aria-label="Help" 
//           onClick={()=> window.open(`${process.env.REACT_APP_HOST_DOMAIN}/docs` , "_blank")}
//           sx={{
//             padding: 0, 
//             border: 'none',  
// 			ml:2,
//             '&:hover': {
              
//               backgroundColor: 'action.hover', 
//             },
            
//           }}
//         >
//           <Box
//             component="img"
//             src="/assets/Help.svg" 
//             alt="" 
//             sx={{
//               width: 40,  
//               height: 40,
//               display: 'block', 
//             }}
//           />
//         </IconButton>
//                                         <Menu
//                                           id="go-to-menu"
//                                           anchorEl={anchorEl}
//                                           open={open}
//                                           onClose={handleClose}
//                                           MenuListProps={{
//                                             'aria-labelledby': 'go-to-button',
//                                           }}
//                                         >
//                                           {navPaneList.filter((e:any)=> e.visibility.includes(role) ).map((option:any) => (
//                                             <MenuItem key={option.value} onClick={(e:any) => navigate(option.nav)}>
//                                               {option.icon}
//                                               <Typography fontFamily="Gilroy-Medium" ml={1}>
//                                                 {option.text}
//                                               </Typography>
//                                             </MenuItem>
//                                           ))}
//                                         </Menu>
                              
// 										 </Box>
		
// 									</Box>

								

// 									</Box>
									

//                   {/* <Box mx={2} sx={{backgroundColor: '#FFFFFF'}} >
// 										<Card elevation={0}>
// 											<CardContent>
				
// 				</CardContent>
// 				</Card>
// 				</Box> */}
// 	  <Box sx={{display:"flex"}} >

			 
// 				<LeftBox>
//           <Box sx={{backgroundColor:"#FFFFFF", mb:2}}>
// 				<Typography fontSize="20px" fontFamily="Gilroy-Bold" mx={4}  pb={1} pt={1}>
// 											Hello, {user.name}!
// 				</Typography>
//         </Box>

// 									<Box >
									
// 									<Link to = "/finops-dashboard" style={{ textDecoration: 'none'}}>
// 									{integrations?.costAgent?.enabled === true &&
// 									(
// 									<Box mx={2} my={2}   >
										
// 					                    <Box
    
//     sx={{
//         // Styles ADDED to this Box:
//         textDecoration: 'none',
//         color: 'inherit',
//         display: 'flex', // Ensures it's a flex item
//         flex: 1, // Moved here
//         margin: '0 4px', // Moved here
//         minWidth: 0, // Moved here
//         borderRadius: 2, // Kept/moved here for clickable area
//         '&:hover': { filter: 'brightness(1.1)' }, // Optional Added

//         // Original styles that remain on this Box (now the Link wrapper):
//         // (None in this specific case, as background etc. were on the inner Box)
//     }}
// >
// 												<Box sx={{
// 												display: 'flex',
// 												flexDirection: "row",
// 												justifyContent: "space-between", // Distribute items evenly
// 												width: '100%',
// 												padding: 0,
// 												// remove flexWrap: 'wrap' to prevent wrapping
// 												}}
// 												>
// 												<Box sx={{
// 													backgroundColor: '#101010',
// 													display: 'flex',
// 													backgroundImage: bigQueryClusterCostRecent > 0 ?`url('assets/red-graph.svg')`: `url('assets/green-graph.svg')`,
// 													backgroundPosition: 'bottom right',
// 													backgroundRepeat: 'no-repeat',
// 													justifyContent: 'flex-start',
// 													borderRadius: 2,
// 													padding: 2,
// 													flex: 1, // Equal distribution of space
// 													margin: '0 4px', // Added spacing between items
// 													minWidth: 0, // prevent overflow if content is too long
// 													minHeight: "10vh",
// 													width: "100%"
// 												}}>
// 													<Box sx={{width: "100%"}}>
// 													<Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center',width: '100%'  }}>
// 													<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" color="#FFFFFF">
// 													Cluster Costing</Typography> <Avatar
																	
// 																	alt="User icon"
// 																	sx={{
// 																	 backgroundColor:"#101010",
																	 
																	  
// 																	}}
// 																  ><RiArchiveDrawerLine /></Avatar>
// 													</Box>
													
// 													<Typography  fontFamily="Gilroy-Bold" fontSize="18px" color="#FFFFFF">
// 													${Math.round(bigQueryClusterCost) }
// 													{/* $2101 */}
// 													</Typography>
// 													<Typography
// 															fontFamily="Gilroy-Medium"
// 															fontSize="12px"
// 															sx={{
// 																display: 'flex',
// 																alignItems: 'center',
// 																color: bigQueryClusterCostRecent > 0 ? "#F04438" : "#12B76A", // Dynamic color
// 															}}
// 															>
// 															{/* Use a conditional to show an arrow up or down */}
// 															<img src= {bigQueryClusterCostRecent > 0 ? "/assets/arrow-up-red.svg" : "/assets/arrow-down-green.svg"} alt="empty" /> 
// 															${Math.abs(Math.round(bigQueryClusterCostRecent))} from last 30 days
// 															{/* $14 */}
															  
// 															</Typography>
// 													</Box>
// 												</Box>

// 												<Box sx={{
// 													backgroundColor: '#101010',
// 													display: 'flex',
// 													backgroundImage: bigQueryApplicationCostRecent > 0 ?`url('assets/red-graph.svg')`: `url('assets/green-graph.svg')`,
// 													backgroundPosition: 'bottom right',
// 													backgroundRepeat: 'no-repeat',
// 													justifyContent: 'flex-start',
// 													borderRadius: 2,
// 													padding: 2,
// 													flex: 1, // Equal distribution of space
// 													margin: '0 4px', // Added spacing between items
// 													minWidth: 0, // prevent overflow if content is too long
// 													minHeight: "10vh",
// 													width: "100%"
// 												}}>
// 													<Box sx={{width: "100%"}}>
// 													<Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center',width: '100%'  }}>
// 													<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" color="#FFFFFF">
// 													Application Costing</Typography> <Avatar
																	
// 																	alt="User icon"
// 																	sx={{
// 																	 backgroundColor:"#101010",
																	 
																	  
// 																	}}
// 																  ><RiArchiveStackLine /></Avatar>
// 													</Box>
													
// 													<Typography  fontFamily="Gilroy-Bold" fontSize="18px" color="#FFFFFF">
													
// 													${Math.round(bigQueryApplicationCost) }
// 													{/* $1314 */}
// 													</Typography>
// 													<Typography
// 															fontFamily="Gilroy-Medium"
// 															fontSize="12px"
// 															sx={{
// 																display: 'flex',
// 																alignItems: 'center',
// 																color: bigQueryApplicationCostRecent > 0? "#F04438" : "#12B76A", // Dynamic color
// 															}}
// 															>
// 															{/* Use a conditional to show an arrow up or down */}
// 															<img src= {bigQueryApplicationCostRecent > 0? "/assets/arrow-up-red.svg" : "/assets/arrow-down-green.svg"} alt="empty" />
// 															 ${Math.abs(Math.round(bigQueryApplicationCostRecent))} from last 30 days
// 															 {/* $37 */}
															
// 															</Typography>

													
// 													</Box>
// 												</Box>

// 												<Box sx={{
// 													backgroundColor: '#101010',
// 													display: 'flex',
// 													backgroundImage: bigQueryServiceCostRecent > 0 ?`url('assets/red-graph.svg')`: `url('assets/green-graph.svg')`,
// 													// backgroundImage: true ?`url('assets/red-graph.svg')`: `url('assets/green-graph.svg')`,
// 													backgroundPosition: 'bottom right',
// 													backgroundRepeat: 'no-repeat',
// 													justifyContent: 'flex-start',
// 													borderRadius: 2,
// 													padding: 2,
// 													flex: 1, // Equal distribution of space
// 													margin: '0 4px', // Added spacing between items
// 													minWidth: 0, // prevent overflow if content is too long
// 													minHeight: "10vh",
// 													width: "100%"
// 												}}>
// 													<Box sx={{width: "100%"}}>
// 													<Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center',width: '100%'  }}>
// 													<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" color="#FFFFFF">
// 													Service Costing</Typography> <Avatar
																	
// 																	alt="User icon"
// 																	sx={{
// 																	 backgroundColor:"#101010",
// 																	}}
// 																  ><RiBubbleChartLine /></Avatar>
// 													</Box>
													
// 													<Typography  fontFamily="Gilroy-Bold" fontSize="18px" color="#FFFFFF">
// 													{/* $316 */}
// 													${Math.round(bigQueryServiceCost) }
// 													</Typography>
// 													<Typography
// 															fontFamily="Gilroy-Medium"
// 															fontSize="12px"
// 															sx={{
// 																display: 'flex',
// 																alignItems: 'center',
// 																color: bigQueryServiceCostRecent > 0 ? "#F04438" : "#12B76A", 
// 																// color: true ? "#F04438" : "#12B76A", 
// 															}}
// 															>
// 																<img src= { bigQueryServiceCostRecent > 0 ? "/assets/arrow-up-red.svg" : "/assets/arrow-down-green.svg"} alt="empty" />  
// 															{/* <img src= { true ? "/assets/arrow-up-red.svg" : "/assets/arrow-down-green.svg"} alt="empty" />   */}
// 															${
// 																Math.abs(Math.round(bigQueryServiceCostRecent))
// 																// 12
// 															} from last 30 days
// 															</Typography>
// 													</Box>
// 												</Box>
											
										
// 											</Box>
// 											</Box>
// 										</Box>)
// 										}</Link>

									
									
									
// 										<Box mx={2}  >
										


// <Card elevation={0} sx={{ borderRadius: "8px" }}>
//   <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
//     <Typography fontFamily="Gilroy-Bold" fontSize="18px" mb={2} sx={{ alignSelf: "flex-start" }}>
//       Resource Overview
//     </Typography>

//     <Box sx={{
//       display: 'flex',
//       flexDirection: "row",
//       justifyContent: "space-between", // Distribute items evenly
//       width: '100%',
//       padding: 0,
//       // remove flexWrap: 'wrap' to prevent wrapping
//     }}>
//       <Box sx={{
//         backgroundColor: '#F8F8F8',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'flex-start',
//         borderRadius: 2,
//         padding: 2,
//         flex: 1, // Equal distribution of space
//         margin: '0 4px', // Added spacing between items
//         minWidth: 0 // prevent overflow if content is too long
//       }}>
//         <Box>
//           <Typography fontFamily="Gilroy-Bold" fontSize="24px">
//             {rolesData[role]?.clustersList ? rolesData[role]?.clustersList : 0}
//           </Typography>
//           <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//             Cluster{(rolesData[role]?.clustersList ?? 0) !== 1 ? 's' : ''}
//           </Typography>
//         </Box>
//       </Box>

//       <Box sx={{
//         backgroundColor: '#F8F8F8',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'flex-start',
//         borderRadius: 2,
//         padding: 2,
//         flex: 1, // Equal distribution of space
//         margin: '0 4px', // Added spacing between items
//         minWidth: 0 // prevent overflow if content is too long
//       }}>
//         <Box>
//           <Typography fontFamily="Gilroy-Bold" fontSize="24px">
//             {rolesData[role]?.applicationsList ? rolesData[role]?.applicationsList : 0}
//           </Typography>
//           <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//             Application{(rolesData[role]?.applicationsList ?? 0) !== 1 ? 's' : ''}
//           </Typography>
//         </Box>
//       </Box>

//       <Box sx={{
//         backgroundColor: '#F8F8F8',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'flex-start',
//         borderRadius: 2,
//         padding: 2,
//         flex: 1, // Equal distribution of space
//         margin: '0 4px', // Added spacing between items
//         minWidth: 0 // prevent overflow if content is too long
//       }}>
//         <Box>
//           <Typography fontFamily="Gilroy-Bold" fontSize="24px">
//             {rolesData[role]?.servicesList ? rolesData[role]?.servicesList : 0}
//           </Typography>
//           <Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
//             Service{(rolesData[role]?.servicesList ?? 0) !== 1 ? 's' : ''}
//           </Typography>
//         </Box>
//       </Box>
//     </Box>
//   </CardContent>
// </Card>

// 										</Box>
// 										{showPolicyOverview && (
//         <Box mx={2} my={2}> {/* Adjusted margin to match other sections */}
//             <Card elevation={0} sx={{ borderRadius: "12px", border: `1px solid ${theme.palette.divider}`, overflow: 'hidden' }}>
//                 <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
//                     {/* Main Title */}
//                     <Typography fontFamily="Gilroy-Bold" fontSize="18px"  sx={{ alignSelf: "flex-start", p: 2, pb: 1}}>
						
//                         Security Overview
//                     </Typography>
// 					{/* --- Checkov Specific Section --- */}
// 					{integrations?.checkov?.enabled === true && (
//                                         // Added a Box wrapper for potential margin/padding between sections
//                                         <Box mb={integrations?.kyverno?.enabled ? 2 : 0}>
// 					<Box  mx={2} my={2} sx={{borderRadius:"16px"}}>
//                     {/* Checkov Header Row */}
//                     <Box sx={{ display: 'flex', alignItems: 'center', background: checkovHeaderGradient, px: 2, py: 1.5 ,borderRadius:"16px"}}>
//                         <img src="/assets/checkov-dashboard.svg" alt="Checkov Logo" style={{ width:40, height: 40, marginRight: theme.spacing(1.5) }} />
//                         <Typography fontFamily="Gilroy-SemiBold" fontSize="16px" sx={{ mr: 0.5 }}> Checkov </Typography>
//                         <Link to="/integrations/checkov-details" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'left' }}>
//                             {/* <Typography variant="caption" sx={{mr: 0.5, '&:hover': { textDecoration: 'underline' }}}>Details</Typography> */}
//                             <ArrowForwardIosIcon sx={{ fontSize: '1rem', color: theme.palette.text.secondary }} />
//                         </Link>
//                     </Box>

//                     {/* Policy Rows Container */}
//                     <Box sx={{ px: 1 }}>
//                         {/* --- Cluster Row --- */}
//                         <Box sx={{ display: 'flex', alignItems: 'flex-start', py: 1.5, px: 1, gap: 2,  '&:hover': { bgcolor: theme.palette.action.hover, borderRadius: '4px'} }}>
//                             <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: 0 }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.75 }}> <RiArchiveDrawerLine style={{ marginRight: '10px', color: iconColor, fontSize: '1.2rem' }} /> <Typography fontFamily="Gilroy-Medium" fontSize="14px"> Clusters: <Typography component="span" fontFamily="Gilroy-SemiBold">{safeClusterSummary.total}</Typography> </Typography> </Box>
//                                 <Box sx={{ display: 'flex', flexWrap: 'wrap', pl: '34px', minHeight: '24px' }}>
//                                     {safeClusterSummary.resources.map(r => (
//                                         <Tooltip key={r.id} title={r.name} arrow placement="top">
//                                             {/* Wrap child in a span */}
//                                             <span>
//                                                 <PolicyIndicatorSquare sx={{ backgroundColor: r.hasFailures ? failColor : passColor, '&:hover': { transform: 'scale(1.4)', zIndex: 2, boxShadow: theme.shadows[3] } }} />
//                                             </span>
//                                         </Tooltip>
//                                     ))}
//                                 </Box>
//                             </Box>
//                             {(safeClusterSummary.violating ?? 0) > 0 && ( <Box sx={{ width: '200px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', pt: 0.5 }}> <Box sx={{ width: '8px', height: '8px', bgcolor: failColor, borderRadius: '2px', mr: 0.75, flexShrink: 0 }} /> <Typography fontFamily="Gilroy-Medium" fontSize="12px" color={violatingTextColor}> {(safeClusterSummary.violating ?? 0)} cluster{(safeClusterSummary.violating ?? 0) !== 1 ? 's' : ''} violating checks</Typography> </Box> )}
//                         </Box>

//                         {/* --- Application Row --- */}
//                          <Box sx={{ display: 'flex', alignItems: 'flex-start', py: 1.5, px: 1, gap: 2, '&:hover': { bgcolor: "#f5f5f5", borderRadius: '4px'} }}>
//                             <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: 0 }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.75 }}> <RiArchiveStackLine style={{ marginRight: '10px', color: iconColor, fontSize: '1.2rem' }} /> <Typography fontFamily="Gilroy-Medium" fontSize="14px"> Applications: <Typography component="span" fontFamily="Gilroy-SemiBold">{safeAppSummary.total}</Typography> </Typography> </Box>
//                                 <Box sx={{ display: 'flex', flexWrap: 'wrap', pl: '34px', minHeight: '24px' }}>
//                                     {safeAppSummary.resources.map(r => (
//                                         <Tooltip key={r.id} title={r.name} arrow placement="top">
//                                              {/* Wrap child in a span */}
//                                             <span>
//                                                 <PolicyIndicatorSquare sx={{ backgroundColor: r.hasFailures ? failColor : passColor, '&:hover': { transform: 'scale(1.4)', zIndex: 2, boxShadow: theme.shadows[3] } }} />
//                                             </span>
//                                         </Tooltip>
//                                     ))}
//                                 </Box>
//                             </Box>
//                             {(safeAppSummary.violating ?? 0) > 0 && ( <Box sx={{ width: '200px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', pt: 0.5 }}> <Box sx={{ width: '8px', height: '8px', bgcolor: failColor, borderRadius: '2px', mr: 0.75, flexShrink: 0 }} /> <Typography fontFamily="Gilroy-Medium" fontSize="12px" color={violatingTextColor}> {(safeAppSummary.violating ?? 0)} application{(safeAppSummary.violating ?? 0) !== 1 ? 's' : ''} violating checks</Typography> </Box> )}
//                         </Box>

//                         {/* --- Service Row --- */}
//                          <Box sx={{ display: 'flex', alignItems: 'flex-start', py: 1.5, px: 1, gap: 2, '&:hover': { bgcolor: theme.palette.action.hover, borderRadius: '4px'} }}>
//                             <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: 0 }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.75 }}> <RiBubbleChartLine style={{ marginRight: '10px', color: iconColor, fontSize: '1.2rem' }} /> <Typography fontFamily="Gilroy-Medium" fontSize="14px"> Services: <Typography component="span" fontFamily="Gilroy-SemiBold">{safeServiceSummary.total}</Typography> </Typography> </Box>
//                                 <Box sx={{ display: 'flex', flexWrap: 'wrap', pl: '34px', minHeight: '24px' }}>
//                                     {safeServiceSummary.resources.map(r => (
//                                         <Tooltip key={r.id} title={r.name} arrow placement="top">
//                                              {/* Wrap child in a span */}
//                                             <span>
//                                                 <PolicyIndicatorSquare sx={{ backgroundColor: r.hasFailures ? failColor : passColor, '&:hover': { transform: 'scale(1.4)', zIndex: 2, boxShadow: theme.shadows[3] } }} />
//                                             </span>
//                                         </Tooltip>
//                                     ))}
//                                 </Box>
//                             </Box>
//                             {(safeServiceSummary.violating ?? 0) > 0 && ( <Box sx={{ width: '200px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', pt: 0.5 }}> <Box sx={{ width: '8px', height: '8px', bgcolor: failColor, borderRadius: '2px', mr: 0.75, flexShrink: 0 }} /> <Typography fontFamily="Gilroy-Medium" fontSize="12px" color={violatingTextColor}> {(safeServiceSummary.violating ?? 0)} service{(safeServiceSummary.violating ?? 0) !== 1 ? 's' : ''} violating checks</Typography> </Box> )}
//                         </Box>
//                    </Box>
// 				   </Box>
// 				   </Box> /* End Checkov Wrapper Box */
//                                     )} {/* End Checkov Conditional Render */}

// 				    {/* --- Kyverno Specific Section --- */}
// 					{integrations?.kyverno?.enabled === true && (
//                                         <Box> {/* Wrapper Box for Kyverno */}
//                                             <Box mx={2} my={1} sx={{ borderRadius: "16px", overflow: 'hidden' }}>
//                                                 {/* Kyverno Header Row */}
//                                                 <Box sx={{ display: 'flex', alignItems: 'center', background: kyvernoHeaderGradient, px: 2, py: 1.5 }}>
//                                                     {/* Make sure this path is correct */}
//                                                     <img src="/assets/kyverno.svg" alt="Kyverno Logo" style={{ width: 40, height: 40, marginRight: theme.spacing(1.5) }} />
//                                                     <Typography fontFamily="Gilroy-SemiBold" fontSize="16px" sx={{ mr: 0.5 }}> Kyverno </Typography>
//                                                     <Link to="/integrations/kyverno-details" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
//                                                         <ArrowForwardIosIcon sx={{ fontSize: '1rem', color: theme.palette.text.secondary }} />
//                                                     </Link>
//                                                 </Box>

//                                                 {/* Kyverno Policy Rows Container */}
//                                                 <Box sx={{ px: 1 }}>
//                                                     {/* --- Kyverno Cluster Row --- */}
//                                                     <Box sx={{ display: 'flex', alignItems: 'flex-start', py: 1.5, px: 1, gap: 2, '&:hover': { bgcolor: theme.palette.action.hover, borderRadius: '4px' } }}>
//                                                         <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: 0 }}>
//                                                             <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.75 }}>
//                                                                 <RiArchiveDrawerLine style={{ marginRight: '10px', color: iconColor, fontSize: '1.2rem' }} />
//                                                                 <Typography fontFamily="Gilroy-Medium" fontSize="14px"> Clusters: <Typography component="span" fontFamily="Gilroy-SemiBold">{safeKyvernoClusterSummary.total}</Typography> </Typography>
//                                                             </Box>
//                                                             <Box sx={{ display: 'flex', flexWrap: 'wrap', pl: '34px', minHeight: '24px' }}>
//                                                                 {safeKyvernoClusterSummary.resources.map(r => (
//                                                                     <Tooltip key={r.id} title={r.name} arrow placement="top">
//                                                                         <span> {/* Tooltip needs a DOM element child */}
//                                                                             {/* Use kyvernoColor and no pass/fail logic */}
//                                                                             <PolicyIndicatorSquare sx={{ backgroundColor: kyvernoColor, '&:hover': { transform: 'scale(1.4)', zIndex: 2, boxShadow: theme.shadows[3] } }} />
//                                                                         </span>
//                                                                     </Tooltip>
//                                                                 ))}
//                                                             </Box>
//                                                         </Box>
//                                                         {/* No violating count text needed for Kyverno */}
//                                                     </Box>
//                                                 </Box> {/* End Kyverno Rows */}
//                                             </Box> {/* End Kyverno Inner Card Box */}
//                                         </Box> /* End Kyverno Wrapper Box */
//                                     )} {/* End Kyverno Conditional Render */}

//                 </CardContent>
//             </Card>
//         </Box>
//     )}
	
// 										<Box mx={2}  my={2} sx={{maxHeight:'80vh',overflowY: "auto"}}>
// 											<Card elevation={0}>
// 												<CardContent>
// 													<Typography fontFamily="Gilroy-Bold" fontSize="18px" gutterBottom>Knowledge Bank</Typography>
// 													{knowledgeBankData.map((item, index) => (
														
// 														<Box key={index} sx={{cursor: 'pointer' }} onClick={() => {window.open(item.url, '_blank', 'noopener noreferrer')}} >
// 														<Box  marginY={1} sx={{display: 'flex', }}>
// 														  {item.image && ( 
// 															<Box sx={{ width: '25%'}} >
// 															  <CardMedia
// 																component="img"
// 																image={item.image}
// 																alt={item.title}
// 																sx={{ width:'100%', height: '10vh', borderRadius:"8px" , display: "flex", alignContent: "center", justifyContent: "center", '& img': {objectFit: 'contain' }}}
// 															  />
// 															</Box>
// 														  )}
// 														  <Box ml={2} sx={{ width: '73%' }}>
															
// 															<Box justifyContent="flex-start" alignItems="center" marginBottom={1}>
		
// 																<Typography px={1} py={0.75} marginBottom={1} fontFamily="Gilroy-Light" fontSize="12px" sx={{backgroundColor:'#F7F6F6', borderRadius:1, whiteSpace: 'nowrap',display: 'inline'}}>{item.author.toUpperCase()} | {item.date}</Typography>
// 															</Box>
// 															<Box justifyContent="flex-start" alignItems="center" >
// 															<Typography fontFamily="Gilroy-Bold" fontSize="14px" align="justify" sx={{overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical',  marginBottom:1 }}>{item.title}</Typography>
															
// 															<Typography fontFamily="Gilroy-Medium" fontSize="12px" align="justify" sx={{overflow: 'hidden', textOverflow: 'ellipsis',display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', marginBottom:1 }}>{item.content}</Typography>
// 															</Box>
															
// 														  </Box>
														  
// 														</Box>
// 														<Divider/>
// 													  </Box>
													  
// 													))}
// 												</CardContent>
// 											</Card>
// 										</Box>
										
// 										<Box mx={2}  my={2}>
// 												<Card elevation={0}>
// 												<Box sx={{maxHeight:'80vh',overflowY: "auto"}}>
// 											<CardContent>
// 											<Typography fontFamily="Gilroy-Bold" fontSize="18px" gutterBottom>Frequently Asked Questions</Typography>
// 												{/* Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora iusto praesentium odio ipsam! Aperiam cumque recusandae omnis? Maiores, sequi totam harum aperiam illo eligendi placeat sapiente minus deserunt repellendus, distinctio incidunt provident ducimus quibusdam minima laboriosam molestias, reiciendis explicabo ad eum inventore consequuntur? Laborum quasi distinctio repellendus. Quasi consequuntur blanditiis neque debitis ullam, nostrum dignissimos deleniti! */}
											
// 												<Box display="flex" gap={2} mt="14px">
// 																											<Button
// 																												sx={{
// 																													borderRadius: 5,
// 																													borderColor: questionsType == "general" ? "#000000" : "#666666",
// 																													color: questionsType == "general" ? "#000000" : "#666666",
// 																													bgcolor: questionsType == "general" ? "#E0E0E0" : "#FFFFFF",
// 																													textTransform: "none",
// 																												}}
// 																												variant="outlined"
																												
// 																												onClick={() => setQuestionsType('general')}
																												
// 																											>
// 																												General
// 																											</Button>

// 																											<Button
// 																												sx={{
// 																													borderRadius: 5,
// 																													borderColor: questionsType == "cluster" ? "#000000" : "#666666",
// 																													color: questionsType == "cluster" ? "#000000" : "#666666",
// 																													bgcolor: questionsType == "cluster" ? "#E0E0E0" : "#FFFFFF",
// 																													textTransform: "none",
// 																												}}
// 																												variant="outlined"
																												
// 																												onClick={() => setQuestionsType('cluster')}
																												
// 																											>
// 																												Cluster
// 																											</Button>
// 																											<Button
// 																												sx={{
// 																													borderRadius: 5,
// 																													borderColor: questionsType == "application" ? "#000000" : "#666666",
// 																													color: questionsType == "application" ? "#000000" : "#666666",
// 																													bgcolor: questionsType == "application" ? "#E0E0E0" : "#FFFFFF",
// 																													textTransform: "none",
																													
// 																												}}
// 																												variant="outlined"
																												
// 																												onClick={() => setQuestionsType('application')}
																											
// 																											>
// 																												Application
// 																											</Button>
// 																											<Button
// 																												sx={{
// 																													borderRadius: 5,
// 																													borderColor: questionsType == "service" ? "#000000" : "#666666",
// 																													color: questionsType == "service" ? "#000000" : "#666666",
// 																													bgcolor: questionsType == "service" ? "#E0E0E0" : "#FFFFFF",
// 																													textTransform: "none",
// 																												}}
// 																												variant="outlined"
																									
// 																												onClick={() => setQuestionsType('service')}
																												
// 																											>
// 																												Service
// 																											</Button>
// 																										</Box>


											
// 												{questionsType? (
// 													<>
// 													{questions[qt].map((item:any,index:any) =>
// 													(
// 														<Box key={index} mb={0}>
														
// 											<Accordion
// 												elevation={0}
// 												sx={{
// 													borderRadius: "8px",
													
// 													"&:before": {
// 														mb: "2px",
// 														display: "none",
// 													},
// 													bgcolor: "white",
													
// 													"& .MuiAccordionSummary-root": { 
// 														padding: "0.5vh 0.5vh", 
// 													},
// 													"& .MuiAccordionDetails-root": { 
// 														padding: "0.5vh 0.5vh 0.5vh", 
// 													},
// 												}}
// 											>
// 												<AccordionSummary sx={{py:0}} expandIcon={<ExpandMore />}>
// 												<Typography fontFamily="Gilroy-Bold" fontSize="14px" >{item.question}</Typography>
// 												</AccordionSummary>
// 												<AccordionDetails sx={{mt:0}}>
													
// 													<Typography fontFamily="Gilroy-Medium" fontSize="12px">{item.answer}</Typography>
// 												</AccordionDetails>
												
// 											</Accordion>
// 											<Divider  />
// 														</Box>
// 													)
// 													)}
// 													</>
// 												): <>false statement</> 

// 												}
// 											</CardContent>
// 											</Box>
// 										</Card>
// 										</Box>
										
// 									</Box>
									
								
//         </LeftBox>
//         <RightBox>
				
			
// 					<Box>

// 					<Card elevation={0} sx={{   height:"30vh"}}  >
					
// 					<iframe
//         width="100%"
//         height="100%" 
//         src="https://www.youtube.com/embed/dFFe_aORDs0?si=UODZ2VpjL3KEBvmv"
//         title="YouTube video player"
//         frameBorder="0"
//         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//         allowFullScreen
        
//         sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock"
//       />

// {/* <iframe
//         src="https://faraday.searce.com" 
//         width="800"
//         height="600" 

//         title="Embedded Content from Example.com"
//         >
//         Your browser doesn't support iframes.
//         </iframe> */}
// 					</Card>
					
// 					</Box>

//           <Divider sx={{ mt: 2, mx: 0 }} />

// 					<Box > 
// 						<Card elevation={0} sx={{minHeight:"40vh" }}>
// 							<CardContent>
// 								<Box >
// 									<Box display={"flex"} justifyContent={"space-between"} alignContent={"center"}>
// 							<Typography  sx={{ textAlign: 'center', mt:1 }} fontFamily="Gilroy-Bold" fontSize="18px" gutterBottom>Updates</Typography>
// 							<TextField
// 								id="time-filter"
// 								select
								
// 								defaultValue={"24hrs"}
// 								onChange={(e) => {
// 									setTimeFilter(e.target.value)
// 								}}
// 							sx={{fontFamily:"Gilroy-Medium", fontSize:"14px", '& .MuiInputLabel-root': { paddingLeft: 0 },
// 							'& .MuiOutlinedInput-input': { padding: '11px 14px' },marginRight:0, marginBottom:1}}
							
// 							>
// 								<MenuItem sx={{fontFamily:"Gilroy-Medium"}} value={"1hr"} >Last Hour</MenuItem>
// 								<MenuItem sx={{fontFamily:"Gilroy-Medium"}} value={"24hrs"} >Recent</MenuItem>
// 								<MenuItem sx={{fontFamily:"Gilroy-Medium"}} value={"All"} >All Updates</MenuItem>
// 							</TextField>
// 									</Box>
// 					{filteredUpdates[timeFilter as times].length ? filteredUpdates[timeFilter as times].map((update :any, index :any) => (
// 					<Box key={index} marginBottom={2} sx={{backgroundColor: statusStyles.Pending.status.includes(update.currentStatus) ? statusStyles.Pending.backgroundImage :  statusStyles.Success.status.includes(update.currentStatus) ? statusStyles.Success.backgroundImage :  statusStyles.Error.status.includes(update.currentStatus) ? statusStyles.Error.backgroundImage : statusStyles.Pending.backgroundImage}}>
					  
// 					  <ListItem>
// 						  <Typography fontFamily="Gilroy-Light" fontSize="14px" sx={{padding: 1, background: "#ffffff"}}>
// 							{update.resourceType.toUpperCase()}</Typography>
// 					  </ListItem>
// 					  <ListItem>
					
// 						<Typography fontFamily="Gilroy-Medium" fontSize="14px" >{`Current ${update.resourceType}: ${update.resourceName?.toUpperCase()} at ${update?.resourceEnvironment} has status: ${update.currentStatus}`}</Typography>
// 						{/* {update.currentStatus == 'rejected' ? <Typography fontFamily="Gilroy-Medium" fontSize="14px">`Reason for rejection` </Typography> : null} */}
// 					  </ListItem>
// 					  <ListItem sx={{color:"rgba(102, 102, 102, 1)", display: "flex",alignItems: "center", }}>
// 					  	<RiCalendarView/>
// 						  {/* <Typography marginLeft={1}>{(new Date(update.updatedAt*1000)).toLocaleDateString("en-IN")}</Typography> */}
// 						  <Typography fontFamily="Gilroy-Medium" fontSize="14px" marginLeft={1}>{convertUnixTimeToDate(update.updatedAt)}</Typography>
// 						  <Box display="flex" alignItems="center" justifyContent="flex-start" marginLeft={2}>
// 									<Avatar
// 										sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
// 										src={update.resourceOwner?.googleProfilePicture}
// 									/>
// 									<Typography fontFamily="Gilroy-Medium" fontSize="14px">
// 										{update.resourceOwner?.name}
// 									</Typography>
// 								</Box>
								
// 					  </ListItem>
// 					  {/* {index < updates.length - 1 && <Divider />} */}
// 					{/* <Typography>{typeof(update.updatedAt)}</Typography> */}
// 					{/* <Typography>{timeDifference(Date.now(),update.updatedAt)}</Typography> */}
// 					</Box>
// 				  )):<Box><Box
// 													sx={{
// 														position: "relative",
// 														top: "50%",
// 														left: "50%",
// 														transform: "translate(-50%, -1%)",
// 														width: "30vw",
// 													}}
// 													display="flex"
// 													flexDirection="column"
// 													flex={1}
// 													alignItems="center"
// 													justifyContent="center"
// 												>
// 													<img src="/assets/inbox-icon.svg" alt="empty" />
// 													<Typography
// 														gutterBottom
// 														fontFamily="Gilroy-Bold"
// 														fontSize="16px"
// 														px={2}
// 														textAlign="center"
// 													>
// 														You are all caught up!
// 													</Typography>
													
// 												</Box></Box>}
// 				  </Box>
// 				  </CardContent>
// 				  </Card>
// 					</Box>
				
				
//         </RightBox>
		

// 			</Box>



// 			</Box>
// 		</Box>
// 	);
// };

// export default DashBoardPage;
